export default {
    'all': 'Allt',
    'archive': 'Geymsla',
    'actions': 'Aðgerðir',
    'download': 'Hala niður',
    'pleaseSelect': 'Vinsamlega veldu',
    'country': 'Land',
    'province': 'Póstfang',
    'district': 'Umdæmi',
    'area': 'Póstnúmer',
    'records': ' ',
    'found': 'Fjöldi',
    'document': 'Skjal',
    'offerDetail': 'Tilboð',
    'print':'Prenta',
    'percent': 'Prósent',
    'noOfBathrooms': 'Baðherbergi',
    'noOfTotalrooms': 'Herbergi alls',
    'feature': 'Lýsing',
    'printing':'Prentun...',
    'loan':'Greiðslur - lán',
    'remove': 'Eyða',
    'advanceFilter': 'Ítarleit',
    'allViewStations':'Allir skoða stöðvar',
    'from': 'frá',
    'to': 'til',
    'insert': 'settu inn',
    'id':'ID',
    'tax': 'Skattur',
    'back': 'aftur',
    'reset': 'Hreinsa',
    'name': 'Nafn',
    'price': 'Verð',
    'address': 'Heimilisfang',
    'batch': 'Breyta völdum aðilum',
    'date':'Dagsetning',
    'findLocation':'Finndu staðsetningu',
    'saleOrRent' : 'Sala / Leiga',
    'yes': 'Já',
    'no': 'Nr',
    'max': 'Hámark',
    'thisFieldIsRequired': 'Þetta reit er krafist',
    'sureToDelete': 'Ertu viss um að þú viljir fjarlægja?',
    'sureToDeleteProperty': 'Ertu viss um að þú viljir fjarlægja eign/eignir úr verkefninu?',
    'mortgageCancelationDate':'Aflýsingardagur',
    'mortgageCancelationDateText':'Aflýsingardagur - texti',
    'unitcode': 'Unit Code',
    'commission.title.property': 'Eign',
    'commission.title.price': 'Verð',
    'commission.title.type': 'Tegund',
    'commission.title.note': 'Athugasemd',
    'commission.title.percentage': 'Prósenta',
    'commission.title.fixed': 'Fast',
    'commission.title.total': 'Heildar',
    'commission.title.dueDate': 'Gildir til:',
    'commission.title.export': 'Sækja',
    'commission.title.contractDate': 'Contract Date',
    'commission.header.commissionReport': 'Commission Report',
    'commission.header.dateFrom': 'Dags. frá',
    'commission.header.dateTo': 'Dags. til',
    'commission.table.export.excel': 'Excel',
    'commission.table.export.pdf': 'Pdf',
    'project.modalConfirm.deleteProjectTitle': 'Eyða verkefni',
    'project.modalConfirm.deleteProjectMessage': 'Viltu eyða verkefninu?',
    'project.modalConfirm.deleteProjectUnitTypeTitle': 'Eyða tegund',
    'project.modalConfirm.deletProjectUnitTypeMessage': 'Viltu eyða tegund?',
    'projectList.title.projectName': 'Nafn verkefnis',
    'projectList.title.location': 'Staðsetning',
    'projectList.title.projectType': 'Tegund verkefnis',
    'projectList.title.unitsV': 'Eining',
    'projectList.title.lastUpdate': 'Síðast uppfært',
    'projectList.title.search': 'Leit',
    'projectList.title.project': 'Verkefnalisti',
    'projectList.button.addProject': 'Bæta við verkefni',
    'projectList.button.updateProject': 'Uppfæra verkefni',
    'projectList.validate.greaterThanFrom' : 'verður að vera stærra en "frá"',
    'projectDetail.button.selectAll': 'Velja allt',
    'projectDetail.button.selectNone': 'Ekkert valið',
    'projectDetail.button.invertSelect': 'Andhverft val',
    'projectDetail.button.batch': 'Hópur',
    'projectDetail.textbox.projectName': 'Nafn verkefnis',
    'projectDetail.dropdown.projectId': 'Númer verkefnis',
    'projectDetail.dropdown.projectType': 'Tegund verkefnis',
    'projectDetail.autocomeplete.developer': 'Verktaki',
    'projectDetail.textbox.totalUnit': 'Fjöldi eininga',
    'projectDetail.dropdown.location': 'Staðsetning',
    'projectDetail.dropdown.area': 'Svæði',
    'projectDetail.textarea.address': 'Heimilisf.',
    'projectDetail.textbox.yearBuilt': 'Upphaf framkvæmda',
    'projectDetail.textbox.yearComplete': 'Lok framkvæmda',
    'projectDetail.dropdown.status': 'Staða',
    'projectDetail.textbox.landSize': 'Stærð lóðar',
    'projectDetail.textbox.rai': 'Rai',
    'projectDetail.textbox.ngan': 'Ngan',
    'projectDetail.textbox.wa': 'Wa',
    'projectDetail.textbox.sqm': 'fm.',
    'projectDetail.textbox.sqw': 'fm.',
    'projectDetail.gallery': 'Myndasafn',
    'projectDetail.floorPlan': 'Grunnflötur',
    'projectDetail.button.upload': 'Hlaða',
    'projectDetail.button.delete': 'Eyða',
    'projectDetail.textarea.remark': 'Athugasemd',
    'projectDetail.textbox.unitType': 'Tegund',
    'projectDetail.textbox.unitName': 'Heiti eininga',
    'projectDetail.textbox.code': 'Kóði',
    'projectDetail.textbox.size': 'Stærð',
    'projectDetail.button.addUnitType': 'Bæta við tegund',
    'projectDetail.tab.unitDetail': 'Nánar',
    'projectDetail.tab.matrixView': 'Afstöðumynd',
    'projectDetail.button.updateProjectUnits': 'Uppfærsla',
    'projectDetail.tab.sales': 'Sala',
    'projectDetail.tab.construction': 'Bygging',
    'projectDetail.advertisementVdo': 'Kynningarmyndband',
    'projectFeature.propertyNearBy': 'Nálægar eignir',
    'projectDetail.button.showEnquiry': 'Fyrirspurnir',
    'projectDetail.button.showUnits': 'Sýna einingar',
    'projectDetail.button.projectReports': 'Skýrslur',
    'projectDetail.button.unitList': 'Eininga Listi',
    'projectDetail.button.addEnquiry': 'Fyrirspurn',
    'projectDetail.button.addUnits': 'Bæta við',
    'projectDetail.button.deleteProject': 'Eyða verkefni',
    'projectDetail.matrix.quickSearch': 'Flýtileit',
    'projectDetail.matrix.all': 'Allt',
    'projectDetail.matrix.unitNumber': 'Númer einingar',  
    'projectDetail.matrix.unitNumber2': 'Skrá númer einingar',
    'projectDetail.matrix.unitType': 'Tegund einingar',
    'projectDetail.matrix.selectUnitType': 'Velja tegund einingar',
    'projectDetail.matrix.price': 'Verð',
    'projectDetail.matrix.lowestPrice': 'Lægsta verð',
    'projectDetail.matrix.saleState': 'Staða',
    'projectDetail.matrix.selectSaleState': 'Velja stöðu eininga',
    'projectDetail.matrix.saleAgent': 'Sölumaður',
    'projectDetail.matrix.selectSaleAgent': 'Velja sölumann',
    'projectDetail.matrix.saleRepresentative': 'Sölumaður',
    'projectDetail.matrix.defect': 'Gallar',
    'projectDetail.matrix.selectDefect': 'Velja galla',
    'projectDetail.matrix.percentComplete': 'Lokið',
    'projectDetail.matrix.markUpPrice': 'Skala upp um (%)',
    'projectDetail.matrix.markDownPrice': 'Skala niður um (%)',
    'projectDetail.matrix.markUpMinPrice': 'Skala lágmarksverð upp um (%)',
    'projectDetail.matrix.markDownMinPrice': 'Skala lágmarksverð niður um (%)',
    'projectDetail.matrix.batch': 'Uppfæra valdar eignir',
    'projectDetail.matrix.useAsterisk': 'Use Asterisk(*) for any character',
    'projectDetail.matrix.markUnit': 'Skölun',
    'projectDetail.matrix.markPrice': 'Verð',
    'projectDetail.matrix.markPercent': 'Prósent(%)',
    'projectDetail.matrix.changeSaleState': 'Staða sölu',
    'projectDetail.matrix.changeSaleRepresentative': 'Sölumaður',
    'projectDetail.matrix.assignToAgent': 'Skrá á sölumann',
    'projectDetail.matrix.selectState': 'Velja stöðu',
    'projectDetail.matrix.selectSalesRepresentative': 'Vinsamlega veljið sölumann',
    'projectDetail.matrix.selectAgent': 'Velja sölumann',
    'projectDetail.matrix.deleteUnits': 'Eyða einingar',
    'projectDetail.matrix.deleteSelectedUnits': 'Fjarlægja eign/eignir úr verkefni',
    'projectDetail.matrix.apply': 'Uppfæra',
    'projectDetail.matrix.addDefect': 'Skrá galla',
    'projectDetail.matrix.deleteDefect': 'Eyða galla',
    'projectDetail.report.unitWithoutUnitTypeWillNotShowinReport': 'Unit without unit type will not show in report',
    'projectDetail.gallery.tooltip': 'Vinsamlega skrifið "banner" fyrir neðan myndina sem nota á sem aðalmynd., Vinsamlega skrifið "logo" fyrir neðan þá mynd sem nota á sem logo. ',
    'projectFeature.transportation': 'Samgöngur',
    'projectFacility.facility': 'Aðstaða',
    'sidebar.email': 'Tölvupóstur',
    'sidebar.account': 'Account',
    'sidebar.enquiry': 'Fyrirspurnir',
    'sidebar.enquiryDetail': 'Fyrirspurnir',
    'sidebar.lead': 'Ábendingar',
    'sidebar.ecommerce': 'Netverslun',
    'sidebar.shop': 'Verslun',
    'sidebar.cart': 'Karfa',
    'sidebar.checkout': 'Útskráning',
    'sidebar.cards': 'Kort',
    'sidebar.maps': 'Kort',
    'sidebar.googleMap': 'Google Map',
    'sidebar.leafletMap': 'Leaflet Map',
    'sidebar.calendar': 'Dagatal',
    'sidebar.notes': 'Athugasemdir',
    'sidebar.todos': 'Verkefni',
    'sidebar.contacts': 'Tengiliðir',
    'sidebar.shuffle': 'Stokka',
    'sidebar.charts': 'Töflur',
    'sidebar.googleCharts': 'Google Carts',
    'sidebar.recharts': 'Recharts',
    'sidebar.reactVis': 'React Vis',
    'sidebar.reactChart2': 'React-Chart-2',
    'sidebar.reactTrend': 'React-Trend',
    'sidebar.eChart': 'Echart',
    'sidebar.forms': 'Forms',
    'sidebar.input': 'Input',
    'sidebar.editor': 'Editor',
    'sidebar.formsWithValidation': 'Forms With Validation',
    'sidebar.progress': 'Progress',
    'sidebar.button': 'Button',
    'sidebar.tab': 'Tab',
    'sidebar.checkbox': 'Checkbox',
    'sidebar.radiobox': 'Radiobox',
    'sidebar.transfer': 'Transfer',
    'sidebar.autocomplete': 'AutoComplete',
    'sidebar.boxOptions': 'Box Options',
    'sidebar.uiElements': 'UI Elements',
    'sidebar.badge': 'Badge',
    'sidebar.card2': 'Card',
    'sidebar.corusel': 'Carousal',
    'sidebar.collapse': 'Collapse',
    'sidebar.popover': 'Pop Over',
    'sidebar.tooltip': 'Tooltip',
    'sidebar.tag': 'Tag',
    'sidebar.timeline': 'Timeline',
    'sidebar.dropdown': 'Dropdown',
    'sidebar.pagination': 'Pagination',
    'sidebar.rating': 'Rating',
    'sidebar.tree': 'Veftré',
    'sidebar.advancedElements': 'Advanced Elements',
    'sidebar.reactDates': 'React Dates',
    'sidebar.codeMirror': 'Code Mirror',
    'sidebar.uppy': 'Uppy Uploader',
    'sidebar.dropzone': 'Drop Zone',
    'sidebar.feedback': 'Feedback',
    'sidebar.alert': 'Aðvörun',
    'sidebar.modal': 'Modal',
    'sidebar.message': 'Skilaboð',
    'sidebar.notification': 'Tilkynningar',
    'sidebar.popConfirm': 'Staðfesting',
    'sidebar.spin': 'Spin',
    'sidebar.tables': 'Tables',
    'sidebar.antTables': 'Ant Tables',
    'sidebar.pages': 'Pages',
    'sidebar.500': '500',
    'sidebar.404': '404',
    'sidebar.signIn': 'Skrá inn',
    'sidebar.signUp': 'Skrá út',
    'sidebar.forgotPw': 'Týnt lykilorð',
    'sidebar.resetPw': 'Endurstilla lykilorð',
    'sidebar.invoice': 'Reikningur',
    'sidebar.menuLevels': 'Menu Levels',
    'sidebar.item1': 'Item 1',
    'sidebar.item2': 'Item 2',
    'sidebar.option1': 'Option 1',
    'sidebar.option2': 'Option 2',
    'sidebar.option3': 'Option 3',
    'sidebar.option4': 'Option 4',
    'sidebar.blankPage': 'Blank Page',
    'sidebar.githubSearch': 'Github Search',
    'sidebar.youtubeSearch': 'Youtube Search',
    'sidebar.salesReport': 'Skýrsla',
    'sidebar.ExcelList': 'Söluskýrsla',
    'sidebar.PropertyReport': 'Property Report',
    'sidebar.PropertyStatusReport': 'Skýrslur',
    'sidebar.contactDetail': 'Nánar um tengilið',
    'sidebar.enquiries': 'Fyrirspurnir',
    'sidebar.interests': 'Ábendingar',
    'sidebar.properties': 'Eign',
    'sidebar.addProject': 'Bæta við verkefni',
    'sidebar.property': 'Eign',
    'sidebar.residential': 'Residential',
    'sidebar.commercial': 'Commercial',
    'languageSwitcher.label': 'Tungumál',
    'themeSwitcher': 'Theme Switcher',
    'themeSwitcher.Sidebar': 'Sidebar',
    'themeSwitcher.Topbar': 'Topbar',
    'themeSwitcher.Background': 'Background',
    'reports.label': 'Skýrsla',
    'feedback.alert.basicTitle': 'Basic Title',
    'feedback.alert.successText': 'Success text',
    'feedback.alert.infoText': 'Info Text',
    'feedback.alert.warningText': 'Warning Text',
    'feedback.alert.errorText': 'Error Text',
    'feedback.alert.closableAlertType': 'Closable Alert Type',
    'feedback.alert.iconAlertType': 'Icon Alert Type',
    'feedback.alert.iconInfoAlertType': 'Icon Info Alert Type',
    'feedback.alert.successTips': 'success tips',
    'feedback.alert.successTipsDescription': 'Detailed description and advices about successful copywriting.',
    'feedback.alert.informationTips': 'Informational Notes',
    'feedback.alert.informationDescription': 'Additional description and informations about copywriting.',
    'feedback.alert.warningTips': 'Warning',
    'feedback.alert.warningDescription': 'This is a warning notice about copywriting.',
    'feedback.alert.errorTips': 'Error',
    'feedback.alert.errorDescription': 'This is an error message about copywriting.',
    'feedback.alert.modalTitle': 'Modal one with customize Footer',
    'feedback.alert.modalSubTitle': 'Basic modal dialog.',
    'feedback.alert.successTitle': 'Success',
    'feedback.alert.infoTitle': 'Info',
    'feedback.alert.errorTitle': 'Error',
    'feedback.alert.warningTitle': 'Warning',
    'feedback.alert.modalBlockTitle': 'Modal',
    'feedback.alert.confirmationModalDialogue': 'Confirmation modal dialog',
    'feedback.alert.simpleModalDialogue': 'Simple modal dialog',
    'feedback.alert.message': 'Message',
    'feedback.alert.normalMessageTitle': 'Normal Message',
    'feedback.alert.normalMessageSubtitle': 'Normal messages as feedbacks.',
    'feedback.alert.displayMessage': 'Display normal message',
    'feedback.alert.displayOtherTypeMessageTitle': 'Other Types of Message',
    'feedback.alert.displayOtherTypeMessageSubTitle': 'Messages of success   error and warning types.',
    'feedback.alert.customizeDurationTitle': 'Customize duration',
    'feedback.alert.customizeDurationSubTitle': 'ustomize message display duration from default 1.5s to 10s.',
    'feedback.alert.customizeDurationButton': 'Customized display duration',
    'feedback.alert.messageLoadingTitle': 'Message of loading',
    'feedback.alert.messageLoadingSubTitle': 'Display a global loading indicator   which is dismissed by itself asynchronously' +
        '.',
    'feedback.alert.displayLoadIndicator': 'Display a loading indicator',
    'feedback.alert.notification': 'Notification',
    'feedback.alert.notificationBasicTitle': 'Basic',
    'feedback.alert.notificationBasicSubTitle': 'The simplest usage that close the notification box after 4.5s.',
    'feedback.alert.notificationBasicDescription': 'Open the notification box',
    'feedback.alert.notificationDurationTitle': 'Duration after which the notification box is closed',
    'feedback.alert.notificationDurationSubTitle': 'Duration can be used to specify how long the notification stays open. After the ' +
        'duration time elapses   the notification closes automatically. If not specified ' +
        '  default value is 4.5 seconds. If you set the value to 0   the notification box' +
        ' will never close automatically.',
    'feedback.alert.notificationwithIconTitle': 'Notification with icon',
    'feedback.alert.notificationwithIconSubTitle': 'A notification box with a icon at the left side.',
    'feedback.alert.notificationwithCustomIconTitle': 'Notification with custom icon',
    'feedback.alert.notificationwithCustomIconSubTitle': 'Normal messages as feedbacks.',
    'feedback.alert.notificationwithCustomButtonTitle': 'Notification with custom button',
    'feedback.alert.notificationwithCustomButtonSubTitle': 'Normal messages as feedbacks.',
    'feedback.alert.popConfirm': 'Pop Confirm',
    'feedback.alert.popConfirm.basicTitle': 'Basic Confirm',
    'feedback.alert.popConfirm.basicSubTitle': 'The basic example.',
    'feedback.alert.popConfirm.delete': 'Delete',
    'feedback.alert.popConfirm.notiWithIconTitle': 'Notification with custom icon',
    'feedback.alert.popConfirm.notiWithIconSubTitle': 'Normal messages as feedbacks.',
    'feedback.alert.popConfirm.TL': 'TL',
    'feedback.alert.popConfirm.top': 'Top',
    'feedback.alert.popConfirm.TR': 'TR',
    'feedback.alert.popConfirm.LT': 'LT',
    'feedback.alert.popConfirm.left': 'Left',
    'feedback.alert.popConfirm.LB': 'LB',
    'feedback.alert.popConfirm.RT': 'RT',
    'feedback.alert.popConfirm.right': 'Right',
    'feedback.alert.popConfirm.RB': 'RB',
    'feedback.alert.popConfirm.Bl': 'BL',
    'feedback.alert.popConfirm.bottom': 'Bottom',
    'feedback.alert.popConfirm.BR': 'BR',
    'feedback.alert.spin': 'Spin',
    'feedback.alert.spin.basicTitle': 'Size Spin',
    'feedback.alert.spin.background': 'Spin With Background',
    'feedback.alert.spin.backgroundDescription': 'Spin With Background description',
    'feedback.alert.spin.loadingState': 'Loading State',
    'feedback.alert.spin.alertTitle': 'Alert message title',
    'feedback.alert.spin.alertDescription': 'Further details about the context of this alert.',
    'feedback.alert.priceIsHigherThanPayment': 'Kaupverð er hærra en greiðslur',
    'feedback.alert.paymentAreHigherThanPrice': 'Greiðslur hærri en kaupverð',
    'feedback.alert.warning.whenChangeTab': 'You haven\'t saved your data in this tab. Do you want to leave without saving?',
    'forms.input.header': 'Input',
    'forms.input.basicTitle': 'Basic usage',
    'forms.input.basicSubTitle': 'Basic usage example.',
    'forms.input.variationsTitle': 'Three sizes of Input',
    'forms.input.variationsSubtitle': 'There are three sizes of an Input box  large (42px  、default (35px   and small (' +
        '30px  . Note  Inside of forms   only the large size is used.',
    'forms.input.groupTitle': 'Input Group',
    'forms.input.groupSubTitle': 'Input.Group example Note  You dont need Col to control the width in the compact ' +
        'mode.',
    'forms.input.autoSizingTitle': 'Autosizing the height to fit the content',
    'forms.input.autoSizingSubTitle': 'autosize prop for a textarea type of Input makes the height to automatically adj' +
        'ust based on the content. An options object can be provided to autosize to speci' +
        'fy the minimum and maximum number of lines the textarea will automatically adjus' +
        't.',
    'forms.input.prePostTabTitle': 'Pre    Post tab',
    'forms.input.prePostTabSubTitle': 'Using pre &amp; post tabs example..',
    'forms.input.textAreaTitle': 'Textarea',
    'forms.input.textAreaSubTitle': 'For multi-line user input cases   an input whose type prop has the value of text' +
        'area can be used.',
    'forms.input.searchTitle': 'Search',
    'forms.input.searchSubTitle': 'Example of creating a search box by grouping a standard input with a search butt' +
        'on',
    'forms.editor.header': 'Editor',
    'forms.formsWithValidation.header': 'Customized Validation Form',
    'forms.formsWithValidation.failLabel': 'Fail',
    'forms.formsWithValidation.failHelp': 'Should be combination of numbers &amp; alphabets',
    'forms.formsWithValidation.warningLabel': 'Warning',
    'forms.formsWithValidation.ValidatingLabel': 'Validating',
    'forms.formsWithValidation.ValidatingHelp': 'The information is being validated...',
    'forms.formsWithValidation.SuccessLabel': 'Success',
    'forms.formsWithValidation.WarninghasFeedbackLabel': 'Warning',
    'forms.formsWithValidation.FailhasFeedbackLabel': 'Fail',
    'forms.formsWithValidation.FailhasFeedbackHelp': 'Should be combination of numbers &amp; alphabets',
    'forms.progressBar.header': 'Progress Bar',
    'forms.progressBar.standardTitle': 'Progress bar',
    'forms.progressBar.standardSubTitle': 'A standard progress bar.',
    'forms.progressBar.circularTitle': 'Circular Progress bar',
    'forms.progressBar.circularSubTitle': 'A circular progress bar.',
    'forms.progressBar.miniTitle': 'Mini size progress bar',
    'forms.progressBar.miniSubTitle': 'Appropriate for a narrow area.',
    'forms.progressBar.miniCircularTitle': 'A smaller circular progress bar.',
    'forms.progressBar.dynamicCircularTitle': 'Dynamic circular progress bar',
    'forms.progressBar.dynamicCircularSubTitle': 'A dynamic progress bar is better.',
    'forms.progressBar.customTextTitle': 'Custom text format',
    'forms.progressBar.customTextSubTitle': 'You can custom text format by setting format.',
    'forms.progressBar.dashboardTitle': 'Dashboard',
    'forms.progressBar.dashboardSubTitle': 'A dashboard style of progress.',
    'forms.button.header': 'Buttons',
    'forms.button.simpleButton': 'Button Type',
    'forms.button.iconButton': 'Button Icon',
    'forms.button.simpleButtonPrimaryText': 'Primary',
    'forms.button.simpleButtonDefaultText': 'Default',
    'forms.button.simpleButtonDashedText': 'Dashed',
    'forms.button.simpleButtonDangerText': 'Danger',
    'forms.button.iconPrimaryButton': 'search',
    'forms.button.iconSimpleButton': 'search',
    'forms.button.iconCirculerButton': 'search',
    'forms.button.iconDashedButton': 'search',
    'forms.button.SizedButton': 'Button Size',
    'forms.button.DisabledButton': 'Button Disabled',
    'forms.button.LoadingButton': 'Button Loading',
    'forms.button.MultipleButton': 'Multiple Button',
    'forms.button.groupButton': 'Button Group',
    'forms.Tabs.header': 'Tabs',
    'forms.Tabs.simpleTabTitle': 'search',
    'forms.Tabs.simpleTabSubTitle': 'Disabled Tabs',
    'forms.Tabs.iconTabTitle': 'Icon Tabs',
    'forms.Tabs.miniTabTitle': 'Mini Tabs',
    'forms.Tabs.extraTabTitle': 'Extra Action Tabs',
    'forms.Tabs.TabpositionTitle': 'Position',
    'forms.Tabs.TabpositionSubTitle': 'Tabss position  left   right   top or bottom',
    'forms.Tabs.cardTitle': 'Card Type Tabs',
    'forms.Tabs.editableTitle': 'Add and Close Tabs',
    'forms.Tabs.verticalTitle': 'Vertical Type Tabs',
    'forms.Tabs.basicTitle': 'Basic Tabs',
    'forms.checkbox.header': 'Checkbox',
    'forms.checkbox.basicTitle': 'Basic Checkbox',
    'forms.checkbox.basicSubTitle': 'Basic usage of checkbox.',
    'forms.checkbox.groupTitle': 'Checkbox Group',
    'forms.checkbox.groupSubTitle': 'Generate a group of checkboxes from an array. Use disabled to disable a checkbox' +
        '.',
    'forms.checkbox.groupCheckTitle': 'Checkbox Group',
    'forms.checkbox.groupCheckSubTitle': 'Generate a group of checkboxes from an array. Use disabled to disable a checkbox' +
        '.',
    'forms.radio.header': 'Radio',
    'forms.radio.simpleTitle': 'Basic Radio',
    'forms.radio.simpleSubTitle': 'The simplest use. Use disabled to disable a radio.',
    'forms.radio.groupTitle': 'Vertical RadioGroup',
    'forms.radio.groupSubTitle': 'Vertical RadioGroup   with more radios.',
    'forms.radio.groupSecondTitle': 'RadioGroup',
    'forms.radio.groupSecondSubTitle': 'A group of radio components.',
    'forms.radio.groupThirdTitle': 'RadioGroup',
    'forms.radio.groupThirdSubTitle': 'A group of radio components.',
    'forms.transfer.header': 'Transfer',
    'forms.transfer.SubTitle': 'Transfer with a search box.',
    'forms.transfer.Title': 'Search',
    'forms.autocomplete.header': 'Autocomplete',
    'forms.autocomplete.simpleTitle': 'Customized',
    'forms.autocomplete.simpleSubTitle': 'You could pass AutoComplete.Option as children of AutoComplete   instead of usin' +
        'g dataSource',
    'forms.autocomplete.customizeTitle': 'Customize Input Component',
    'forms.autocomplete.customizeSubTitle': 'Customize Input Component',
    'uiElements.badge.badge': 'Badge',
    'uiElements.badge.basicExample': 'Basic Example',
    'uiElements.badge.basicExampleSubTitle': 'Simplest Usage. Badge will be hidden when count is 0   but we can use showZero t' +
        'o show it.',
    'uiElements.badge.overflowCount': 'Overflow Count',
    'uiElements.badge.overflowCountSubTitle': 'OverflowCount is displayed when count is larger than overflowCount. The default ' +
        'value of overflowCount is 99.',
    'uiElements.badge.status': 'Status',
    'uiElements.badge.statusSubTitle': 'Standalone badge with status.',
    'uiElements.badge.success': 'Success',
    'uiElements.badge.error': 'Error',
    'uiElements.badge.default': 'Default',
    'uiElements.badge.processing': 'Processing',
    'uiElements.badge.warning': 'Warning',
    'uiElements.badge.redBadge': 'Red badge',
    'uiElements.badge.redBadgeSubTitle': 'This will simply display a red badge   without a specific count.',
    'uiElements.badge.linkSomething': 'Link something',
    'uiElements.cards.cards': 'Cards',
    'uiElements.cards.basicCard': 'Basic card',
    'uiElements.cards.basicCardSubTitle': 'A basic card containing a title   content and an extra corner content.',
    'uiElements.cards.more': 'More',
    'uiElements.cards.cardTitle': 'Card Title',
    'uiElements.cards.cardContent': 'Card content',
    'uiElements.cards.lorem': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam   quis no' +
        'strud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    'uiElements.cards.noBorder': 'No Border',
    'uiElements.cards.noBorderSubTitle': 'A borderless card on a gray background.',
    'uiElements.cards.gridCard': 'Grid card',
    'uiElements.cards.gridCardSubTitle': 'Cards usually cooperate with grid layout in overview page.',
    'uiElements.cards.loadingCard': 'Loading card',
    'uiElements.cards.loadingCardSubTitle': 'Shows a loading indicator while the contents of the card is being fetched.',
    'uiElements.cards.whateverContent': 'Whatever content',
    'uiElements.cards.customizedContentTitle': 'Customized Content',
    'uiElements.cards.customizedContent': 'Shows a loading indicator while the contents of the card is being fetched.',
    'uiElements.cards.europeStreetBeat': 'Europe Street beat',
    'uiElements.cards.instagram': 'www.instagram.com',
    'uiElements.carousel.carousel': 'Carousal',
    'uiElements.carousel.verticalCarousel': 'Vertical Carousel',
    'uiElements.carousel.verticalCarouselSubTitle': 'Vertical pagination. use   vertical=true',
    'uiElements.carousel.basicCarousel': 'Basic Carousel',
    'uiElements.carousel.basicCarouselSubTitle': 'Basic usage',
    'uiElements.carousel.fadeInTransition': 'Fade In Transition',
    'uiElements.carousel.fadeInTransitionSubTitle': 'Slides use fade for transition.   effect=fade',
    'uiElements.carousel.scrollAutomatically': 'Scroll Automatically',
    'uiElements.carousel.scrollAutomaticallySubTitle': 'Timing of scrolling to the next card  picture. autoplay',
    'uiElements.collapse.collapse': 'Collapse',
    'uiElements.collapse.collapseSubTitle': 'More than one panel can be expanded at a time   the first panel is initialized t' +
        'o be active in this case. use   defaultActiveKey=  [keyNum]',
    'uiElements.collapse.text': 'A dog is a type of domesticated animal. Known for its loyalty and faithfulness  ' +
        ' it can be found as a welcome guest in many households across the world.',
    'uiElements.collapse.headerOne': 'This is panel header 1',
    'uiElements.collapse.headerTwo': 'This is panel header 2',
    'uiElements.collapse.headerThree': 'This is panel header 3',
    'uiElements.collapse.headerNested': 'This is panel nest panel',
    'uiElements.collapse.nestedExample': 'Nested Example',
    'uiElements.collapse.nestedExampleSubTitle': 'Collapse is nested inside the Collapse.',
    'uiElements.collapse.borderlessExample': 'Borderless Example',
    'uiElements.collapse.borderlessExampleSubTitle': 'A borderless style of Collapse. use   bordered=  false',
    'uiElements.collapse.accordion': 'Accordion',
    'uiElements.collapse.accordionSubTitle': 'Accordion mode   only one panel can be expanded at a time. The first panel will ' +
        'be expanded by default. use accordion',
    'uiElements.popover.popover': 'Popover',
    'uiElements.popover.basicExample': 'Basic Example',
    'uiElements.popover.basicExampleSubTitle': 'The most basic example. The size of the floating layer depends on the contents r' +
        'egion.',
    'uiElements.popover.hoverMe': 'Hover me',
    'uiElements.popover.title': 'Title',
    'uiElements.popover.titleTrigger': 'Three ways to trigger',
    'uiElements.popover.titleTriggerSubTitle': 'Mouse to click   focus and move in.',
    'uiElements.popover.focusMe': 'Focus me',
    'uiElements.popover.clickMe': 'Click me',
    'uiElements.popover.placement': 'Placement',
    'uiElements.popover.placementSubTitle': 'There are 12 placement options available.',
    'uiElements.popover.top': 'Top',
    'uiElements.popover.topLeft': 'Top Left',
    'uiElements.popover.topRight': 'Top Right',
    'uiElements.popover.leftTop': 'Left Top',
    'uiElements.popover.left': 'Left',
    'uiElements.popover.leftBottom': 'Left Bottom',
    'uiElements.popover.rightTop': 'Right Top',
    'uiElements.popover.right': 'Right',
    'uiElements.popover.bottom': 'Bottom',
    'uiElements.popover.bottomLeft': 'Bottom Left',
    'uiElements.popover.bottomRight': 'Bottom Right',
    'uiElements.popover.boxTitle': 'Controlling the close of the dialog',
    'uiElements.popover.boxSubTitle': 'Use visible prop to control the display of the card.',
    'uiElements.popover.TR': 'TR',
    'uiElements.popover.TL': 'TL',
    'uiElements.popover.LT': 'LT',
    'uiElements.popover.LB': 'LB',
    'uiElements.popover.RT': 'RT',
    'uiElements.popover.RB': 'RB',
    'uiElements.popover.BL': 'BL',
    'uiElements.popover.BR': 'BR',
    'uiElements.popover.close': 'Close',
    'uiElements.tooltip.tooltip': 'Tooltip',
    'uiElements.tooltip.tooltipContent': 'Tooltip Content',
    'uiElements.tooltip.basicExample': 'Basic Example',
    'uiElements.tooltip.basicExampleSubTitle': 'The simplest usage.',
    'uiElements.tooltip.placementTitle': 'Placement',
    'uiElements.tooltip.placementSubTitle': 'The ToolTip has 12 placements choice.',
    'uiElements.tooltip.TL': 'TL',
    'uiElements.tooltip.TR': 'TR',
    'uiElements.tooltip.LT': 'LT',
    'uiElements.tooltip.LB': 'LB',
    'uiElements.tooltip.RT': 'RT',
    'uiElements.tooltip.RB': 'RB',
    'uiElements.tooltip.BL': 'BL',
    'uiElements.tooltip.BR': 'BR',
    'uiElements.tooltip.bottom': 'Bottom',
    'uiElements.tooltip.right': 'Right',
    'uiElements.tooltip.left': 'Left',
    'uiElements.tooltip.top': 'Top',
    'uiElements.tooltip.tooltipContentSpan': 'Tooltip will show when mouse enter.',
    'uiElements.tooltip.contentSpan': 'Tooltip Content',
    'uiElements.tags.tags': 'Tags',
    'uiElements.tags.basicExample': 'Basic Example',
    'uiElements.tags.basicExampleSubTitle': 'Usage of basic Tag   and it could be closable by set closable property. Closable' +
        ' Tag supports onClose afterClose events.',
    'uiElements.tags.tagOne': 'Tag 1',
    'uiElements.tags.tagTwo': 'Tag 2',
    'uiElements.tags.link': 'Link',
    'uiElements.tags.preventDefault': 'Prevent Default',
    'uiElements.tags.colorfulTag': 'Colorful Tag',
    'uiElements.tags.hotTags': 'Hot Tags',
    'uiElements.tags.hotTagsSubTitle': 'Select your favourite topics.',
    'uiElements.tags.hots': 'Hots',
    'uiElements.tags.addRemoveDynamically': 'Add & Remove Dynamically',
    'uiElements.tags.addRemoveDynamicallySubTitle': 'Generating a set of Tags by array   you can add and remove dynamically. Its base' +
        'd on afterClose event   which will be triggered while the close animation end.',
    'uiElements.tags.newTag': '+ New Tag',
    'uiElements.timeline.timeline': 'Timeline',
    'uiElements.timeline.basicExample': 'Basic Example',
    'uiElements.timeline.basicTimeline': 'Basic timeline',
    'uiElements.timeline.lastNode': 'Last Node',
    'uiElements.timeline.lastNodeContent': 'When the timeline is incomplete and ongoing   put a ghost node at last. set   pe' +
        'nding=  true     or   pending=  a React Element',
    'uiElements.timeline.seeMore': 'See more',
    'uiElements.timeline.custom': 'Custom',
    'uiElements.timeline.customContent': 'Set a node as an icon or other custom element.',
    'uiElements.timeline.colorExample': 'Color Example',
    'uiElements.timeline.colorExampleContent': 'Set the color of circles. green means completed or success status   red means wa' +
        'rning or error   and blue means ongoing or other default status.',
    'uiElements.timeline.createServiceSite': 'Create a services site 2015-09-01',
    'uiElements.timeline.solveInitialNetwork': 'Solve initial network problems 2015-09-01',
    'uiElements.timeline.networkProblemSolved': 'Network problems being solved 2015-09-01',
    'uiElements.timeline.technicalTesting': 'Technical testing 2015-09-01',
    'uiElements.dropdown.dropdown': 'Dropdown',
    'uiElements.dropdown.hoverDropdown': 'Hover Drop Down',
    'uiElements.dropdown.hoverMe': 'Hover me',
    'uiElements.dropdown.hoverPlacement': 'Hover Placement Drop Down',
    'uiElements.dropdown.hoverDisableLink': 'Hover Drop Down with Disable link',
    'uiElements.dropdown.clickedDropdown': 'Clicked Drop Down',
    'uiElements.dropdown.buttonDropdown': 'Button with dropdown menu',
    'uiElements.pagination.pagination': 'Pagination',
    'uiElements.pagination.basic': 'Basic',
    'uiElements.pagination.more': 'More',
    'uiElements.pagination.changer': 'Changer',
    'uiElements.pagination.jumper': 'Jumper',
    'uiElements.pagination.miniSize': 'Mini Size',
    'uiElements.pagination.simpleMode': 'Simple Mode',
    'uiElements.pagination.controlled': 'Controlled',
    'uiElements.pagination.totalNumber': 'Total Number',
    'uiElements.rating.rating': 'Rating',
    'uiElements.rating.basicExample': 'Basic Example',
    'uiElements.rating.basicExampleSubTitle': 'The simplest usage.',
    'uiElements.rating.halfStar': 'Half star',
    'uiElements.rating.halfStarSubTitle': 'Support select half star.',
    'uiElements.rating.showCopywriting': 'Show copywriting',
    'uiElements.rating.showCopywritingSubTitle': 'Add copywriting in rate components.',
    'uiElements.rating.readOnly': 'Read only',
    'uiElements.rating.readOnlySubTitle': 'Read only   cant use mouse to interact.',
    'uiElements.rating.otherCharacter': 'Other Character',
    'uiElements.rating.otherCharacterSubTitle': 'Replace the default star to other character like alphabet   digit   iconfont or ' +
        'even Chinese word.',
    'uiElements.tree.tree': 'Tree',
    'uiElements.tree.basicExample': 'Basic example',
    'uiElements.tree.basicExampleSubTitle': 'The most basic usage   tell you how to use checkable   selectable   disabled   d' +
        'efaultExpandKeys   and etc.',
    'uiElements.tree.basicControlledExample': 'Basic controlled example',
    'uiElements.tree.basicControlledExampleSubTitle': 'basic controlled example',
    'uiElements.tree.draggableExample': 'Draggable example',
    'uiElements.tree.draggableExampleSubTitle': 'Drag treeNode to insert after the other treeNode or insert into the other parent' +
        ' TreeNode.',
    'uiElements.tree.loadAsync': 'Load data asynchronously',
    'uiElements.tree.loadAsyncSubTitle': 'To load data asynchronously when click to expand a treeNode.',
    'uiElements.tree.searchableExample': 'Searchable example',
    'uiElements.tree.searchableExampleSubTitle': 'Searchable Tree',
    'uiElements.tree.treeWithLine': 'Tree With Line',
    'shuffle.descriptionOne': 'Netscape 2.0 ships   introducing Javascript',
    'shuffle.descriptionTwo': 'Jesse James Garrett releases AJAX spec',
    'shuffle.descriptionThree': 'jQuery 1.0 released',
    'shuffle.descriptionFour': 'First underscore.js commit',
    'shuffle.descriptionFive': 'Backbone.js becomes a thing',
    'shuffle.descriptionSix': 'Angular 1.0 released',
    'shuffle.descriptionSeven': 'React is open-sourced; developers rejoice',
    'toggle.list': 'List',
    'toggle.grid': 'Grid',
    'toggle.ascending': 'Ascending',
    'toggle.descending': 'Descending',
    'toggle.shuffle': 'Shuffle',
    'toggle.rotate': 'Rotate',
    'toggle.addItem': 'Add Item',
    'toggle.removeItem': 'Remove Item',
    'contactlist.searchContacts': 'Search Contacts',
    'contactlist.addNewContact': 'Nýr tengiliður',
    'notes.ChoseColor': 'Choose a color for your note',
    'notes.addNote': 'Add New Note',
    'page404.title': '404',
    'page404.subTitle': 'Looks like you got lost',
    'page404.description': 'The page youre looking for doesnt exist or has been moved.',
    'page404.backButton': 'BACK HOME',
    'page500.title': '500',
    'page500.subTitle': 'Internal Server Error',
    'page500.description': 'Something went wrong. Please try again later.',
    'page500.backButton': 'BACK HOME',
    'page.forgetPassTitle': 'Isomorphic',
    'page.forgetPassSubTitle': 'Forgot Password?',
    'page.forgetPassDescription': 'Enter your email and we send you a reset link.',
    'page.sendRequest': 'Send request',
    'page.resetPassTitle': 'Isomorphic',
    'page.resetPassSubTitle': 'Reset Password',
    'page.resetPassDescription': 'Enter new password and confirm it.',
    'page.resetPassSave': 'Save',
    'page.signInTitle': 'Saga Property',
    'page.signInRememberMe': 'Remember me',
    'page.signInButton': 'Sign in',
    'page.signInPreview': 'username: demo   password: demodemo   or just click on any button.',
    'page.signInFacebook': 'Sign in with Facebook',
    'page.signInGooglePlus': 'Sign in with Google Plus',
    'page.signInAuth0': 'Sign in with Auth0',
    'page.signInForgotPass': 'Forgot password',
    'page.signInCreateAccount': 'Create an Isomorphoic account',
    'page.signUpTitle': 'Isomorphic',
    'page.signUpTermsConditions': 'I agree with terms and condtions',
    'page.signUpButton': 'Sign Up',
    'page.signUpFacebook': 'Sign up with Facebook',
    'page.signUpGooglePlus': 'Sign up with Google Plus',
    'page.signUpAuth0': 'Sign Up with Auth0',
    'page.signUpAlreadyAccount': 'Already have an account? Sign in.',
    'page.signingIn': 'Logging in..',
    'page.signInInvalidInput': 'Invalid login or password',
    'login.invalidToken': 'Invalid login token',
    'page.selectOffice': 'Select Office',
    'widget.reportswidget.label': 'Income',
    'widget.reportswidget.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.singleprogresswidget1.label': 'Markaðssetning',
    'widget.singleprogresswidget2.label': 'Auglýsingar',
    'widget.singleprogresswidget3.label': 'Ráðgjöf',
    'widget.singleprogresswidget4.label': 'Verktakar',
    'widget.stickerwidget1.number': '210',
    'widget.stickerwidget1.text': 'Ólesin skilaboð',
    'widget.stickerwidget2.number': '1749',
    'widget.stickerwidget2.text': 'Hlaða mynd',
    'widget.stickerwidget3.number': '3024',
    'widget.stickerwidget3.text': 'Fjöldi skilaboða',
    'widget.stickerwidget4.number': '54',
    'widget.stickerwidget4.text': 'Pantanir',
    'widget.salewidget1.label': 'Tekjur',
    'widget.salewidget1.price': '$15000',
    'widget.salewidget1.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.salewidget2.label': 'Tekjur',
    'widget.salewidget2.price': '$15000',
    'widget.salewidget2.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.salewidget3.label': 'Tekjur',
    'widget.salewidget3.price': '$15000',
    'widget.salewidget3.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.salewidget4.label': 'Tekjur',
    'widget.salewidget4.price': '$15000',
    'widget.salewidget4.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.cardwidget1.number': '110',
    'widget.cardwidget1.text': 'Ný skilaboð',
    'widget.cardwidget2.number': '100%',
    'widget.cardwidget2.text': 'Fjöldi',
    'widget.cardwidget3.number': '137',
    'widget.cardwidget3.text': 'Árangur',
    'widget.progresswidget1.label': 'Hlaða niður',
    'widget.progresswidget1.details': '50% Complete',
    'widget.progresswidget2.label': 'Support',
    'widget.progresswidget2.details': '80% Satisfied Customer',
    'widget.progresswidget3.label': 'Upload',
    'widget.progresswidget3.details': '65% Complete',
    'widget.vcardwidget.name': 'Jhon Doe',
    'widget.vcardwidget.title': 'Sr. iOS Developer',
    'widget.vcardwidget.description': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r ammet dolar consectetur adipisicing elit',
    'checkout.billingform.firstname': 'Fornafn',
    'checkout.billingform.lastname': 'Eftirnafn',
    'checkout.billingform.company': 'Heiti fyrirtækis',
    'checkout.billingform.email': 'Tölvupóstur',
    'checkout.billingform.mobile': 'Farsími',
    'checkout.billingform.country': 'Land',
    'checkout.billingform.city': 'Borg',
    'checkout.billingform.address': 'Heimilisfang',
    'checkout.billingform.addressoptional': 'Númer íbúðar (valkvætt)',
    'checkout.billingform.checkbox': 'Búa til reikning?',
    'antTable.title.image': 'Mynd',
    'antTable.title.firstName': 'Fornafn',
    'antTable.title.lastName': 'Eftirnafn',
    'antTable.title.city': 'Borg',
    'antTable.title.street': 'Gata',
    'antTable.title.email': 'Tölvupóstur',
    'antTable.title.dob': 'DOB',
    'Map.leaflet.basicTitle': 'Basic Map',
    'Map.leaflet.basicMarkerTitle': 'Basic Map(With Default Marker',
    'Map.leaflet.leafletCustomMarkerTitle': 'Basic Map(With Custom Icon Marker)',
    'Map.leaflet.leafletCustomHtmlMarkerTitle': 'Basic Map(With Custom Html Marker',
    'Map.leaflet.leafletMarkerClusterTitle': 'Basic Map(With Marker Cluster',
    'Map.leaflet.leafletRoutingTitle': 'Basic Map Routing',
    'Component.contacts.noOption': 'Engir tengiliðir fundust.',
    'email.send': 'SENDA',
    'email.cancel': 'HÆTTA VIÐ',
    'email.compose': 'NÝTT',
    'email.noMessage': 'Vinsamlega veldu skeyti til að lesa.',
    'themeSwitcher.purchase': 'PANTA',
    'themeSwitcher.settings': 'Stillingar',
    'sidebar.selectbox': 'Velja',
    'sidebar.frappeChart': 'Frappe Charts',
    'topbar.help': 'Hjálp',
    'topbar.logout': 'Skrá út',
    'topbar.viewAll': 'Sjá allt',
    'topbar.viewCart': 'Skoða körfu',
    'topbar.totalPrice': 'Heildarverð',
    'sidebar.projectDetail': 'Verkefni',
    'sidebar.projectList': 'Verkefnalisti',
    'sidebar.propertyList': 'Eignalisti',
    'dashboard': 'Dashboard',
    'sidebar.settings': 'Stillingar',
    'sidebar.settings.employeelist': 'Starfslisti',
    'sidebar.settings.officelist': 'Skrifstofaupplýsingar',
    'modalConfirm.button.confirm': 'Staðfesta',
    'modalConfirm.button.ContinueAnyWay': 'Halda áfram',
    'modalConfirm.button.cancel': 'Hætta við',
    'commission.title.agentName': 'Sölumaður',
    'commission.title.commission': 'Þóknun',
    'offer.date': 'Dagsetning',
    'offer.documentName': 'Heiti',
    'offer.offerName': 'Tilboð',
    'offer.agentName': 'Starfsmaður',
    'offer.createOffer': 'Búa til tilboð',
    'offer.createContract': 'Búðu til samning',
    'offer.detail.header.detail': 'Nánar um tilboð',
    'offer.detail.header.amount': 'Fjárhæð',
    'offer.detail.header.validityPeriod': 'Gildistími',
    'offer.detail.header.buyerInformation': 'Upplýsingar um kaupanda',
    'offer.detail.header.sellerInformation': 'Upplýsingar seljanda',
    'offer.detail.header.sellerAndBuyerInformation': 'Seljandi/Kaupandi',
    'offer.detail.header.sellingInformationWillPullFromPropertyOwner': 'Selja upplýsingar munu draga frá eiganda eiganda upplýsingar',
    'offer.detail.name': 'Tilboð',
    'offer.detail.insuranceCompany': 'Tryggingafélag',
    'offer.detail.pleaseSelectInsuranceCompany': 'Veljið tryggingafélag',
    'offer.detail.offerStatus': 'Staða tilboðs',
    'offer.detail.contract': 'Samningur',
    'offer.detail.contract.createFromThisOffer': 'Búa til nýjan samning, byggðan á þessu tilboði.',
    'offer.detail.contract.cannotCreateContractFromthisOffer': 'Samningur er ekki hægt að búa til með því að hafna tilboðinu',
    'offer.detail.offeredPrice': 'Verðtilboð',
    'offer.detail.deposit': 'Innborgun',
    'offer.detail.validFrom': 'Gildir frá',
    'offer.detail.validUntil': 'Gildir til',
    'offer.status.firstOffer': 'Fyrsta boð',
    'offer.status.counterOffer': 'Gagntilboð',
    'offer.status.acceptedOffer': 'Samþykkt tilboð',
    'offer.status.declinedOffer': 'Tilboði hafnað',
    'offer.button.update': 'Uppfæra',
    'offer.button.create': 'Búa til tilboð',
    'offer.description.buyerProvision': 'Fyrirvari kaupanda',
    'offer.description.ownerProvision': 'Fyrirvari seljanda',
    'offer.description.backside':'Baksiða',
    'offer.description.documentTemplate':'Bakhliðatextar',
    'offer.payment':'Greiðslur',
    'offer.payment.appraisal': 'Mat',
    'offer.payment.propertyAppraisal':'Fasteignamat',
    'offer.payment.loanDisclaimer':'Lán - fyrirvari',
    'buyerInformation.name': 'Nafn',
    'buyerInformation.homePhone': 'Heimasími',
    'buyerInformation.nationalId': 'Kennitala',
    'buyerInformation.workPhone': 'Vinnusími',
    'buyerInformation.address': 'Heimilisfang',
    'buyerInformation.mobilePhone': 'Farsími',
    'buyerInformation.ownerPercent': 'Eignarhluti',
    'buyerInformation.lineId': 'Line ID',
    'buyerInformation.email': 'Tölvupóstur',
    'buyerInformation.addOneMoreBuyer': 'Bæta við kaupendum',
    'buyerInformation.addOneMoreRenter': 'Bættu við einum leigjanda í viðbót',
    'buyerInformation.notFoundContact': 'Fannst ekki (vinsamlegast bættu við í tengiliðum fyrst)',
    'buyerInformation.signature': 'Undirskrift',
    'buyerInformation.hideBuyerName': 'Fela kaupanda nafn',
    'buyerInformation.displayInBuyerList': 'Sýna í kaupanda lista',
    'buyerInformation.displayInSellerList': 'Sýna í seljanda lista',
    'buyerInformation.displaySignature': 'Sýna undirskrift',
    // CONTRACT MODULE
    'contract.contractPrice': 'Kaupverð',
    'contract.menu.contractDetail': 'Samningsatriði',
    'contract.menu.paymentBreakdown': 'Sundurliðun greiðslu',
    'contract.menu.text': 'Texti',
    'contract.menu.commission': 'Þóknun',
    'contract.menu.history': 'Saga',
    'contract.menu.deedDetail': 'Afsal',
    'contract.menu.deedDescription': 'Lýsing',
    'contract.detail.title.contractDetail': 'Samningsatriði',
    'contract.detail.contractName': 'Samningur',
    'contract.detail.insuranceCompany': 'Tryggingafélag',
    'contract.detail.associatedOffer': 'Tengd tilboð',
    'contract.detail.contractDate': 'Dags. samnings',
    'contract.detail.transferDate': 'Afhendingardags.',
    'contract.detail.deedDate': 'Útgáfudagur afsals',
    'contract.detail.transferDateText': 'Afhendingardags. (Texti)',
    'contract.detail.previousDeedDue': 'Dags. veðbókar',
    'contract.detail.title.buyerInfomation': 'Upplýsingar um kaupanda',
    'contract.detail.enterContractName': 'Heiti samnings',
    'contract.paymentBreakdown.title.paymentBreakdown': 'Sundurliðun greiðslu',
    'contract.paymentBreakdown.propertyAppraisal': 'Fasteignamat',
    'contract.paymentBreakdown.fireAppraisal': 'Brunabótarmat',
    'contract.paymentBreakdown.landAppraisal': 'Lóðarmat',
    'contract.text.title.frontSideText': 'Texti á framhlið',
    'contract.text.title.buyerConditions': 'Skilyrði kaupanda',
    'contract.text.title.sellerConditions': 'Skilyrði seljanda',
    'contract.text.title.backSideText': 'Texti á bakhlið',
    'contract.text.templates': 'Bakhliðatextar',
    'contract.text.signningLcation': 'staðsetning undirskriftar',
    'contract.commission.title.commissionDistribution': 'Skipting þóknunar',
    'contract.commission.title.PaymentReceived': 'Greiðsla móttekin',
    'contract.commission.commissionPercent': 'Þóknun í prósentum',
    'contract.commission.commissionFixed': 'Þóknun, föst fjárhæð',
    'contract.commission.commissionTotal': 'Heildarþóknun',
    'contract.commission.receiver': 'Móttekið',
    'contract.commission.fixed': 'Fast',
    'contract.commission.total': 'Heildar',
    'contract.commission.grandTotal': 'Samtals',
    'contract.commission.receivedOn': 'Móttekið',
    'contract.history.title.history': 'Saga',
    'contract.history.createOn': 'Búið til',
    'contract.history.agentName': 'Sölumaður',
    'contract.history.action': 'Framkvæmd',
    'excelList.header.allEmployeeCommission': 'Þóknanir starfsmanna',
    'excelList.button.exportExcel': 'Birta lista í Excel',
    'contract.createDeed': 'Búa til afsal',
    'contract.deed.deedPrice': 'Kaupverð',
    'contract.deed': 'Afsöl',
    'contract.deed.deedDetail': 'Afsal',
    'contract.deed.deedName': 'Afsal - heiti',
    'contract.deed.enterDeedName': 'Deed Name',
    'contract.deed.deedDescription': 'Deed Description',
    'contract.deed.insurance': 'Insurance',
    'contract.deed.buyerProvision': 'Fyrirvari kaupanda',
    'contract.deed.ownerProvision': 'Fyrirvari seljanda',
    'contract.deed.salesRepresentative': 'Sölumaður',
    'contract.deed.enterBuyerProvision': 'Enter Buyer Provision',
    'contract.deed.enterOwnerProvision': 'Enter Owner Provision',
    'contract.deed.paymentBreakdown.title.paymentBreakdown': 'Sundurliðun greiðslu',
    'contract.deed.paymentBreakdown.propertyAppraisal': 'Fasteignamat',
    'contract.deed.paymentBreakdown.fireAppraisal': 'Brunabótamat',
    'contract.deed.paymentBreakdown.landAppraisal': 'Lóðamat',
    'contract.deed.paymentBreakdown.DeliveryDateText': 'Afhendingardags. (Texti)',
    'contract.deed.paymentBreakdown.DeliveryDate': 'Afhendingardags',
    'contract.deed.paymentBreakdown.OfferPrice': 'Kaupverð',
    'contract.deed.paymentBreakdown.Town': 'Staður',
    'contract.deed.paymentBreakdown.SignDate': 'Dagsetning',
    'contract.deed.paymentBreakdown.ContractDate': 'Dags. samnings',
    'contract.deed.paymentBreakdown.DeedDate': 'Verklok',
    'contract.deed.paymentBreakdown.TransferDate': 'Aflýsingardagur',
    'contract.deed.paymentBreakdown.PreviousDeedDate':'Fyrri dagsetning verkloka',
    'contract.deed.associatedContract': 'Tilsvarandi kaupsamningur',
    'contract.deed.paymentBreakdown.rentPeriod': 'Rent Period',
    'contract.deed.paymentBreakdown.advancePayment': 'Advance Payment',
    'contract.deed.paymentBreakdown.paymentFrequency': 'Payment Frequency',
    'contract.deed.paymentBreakdown.moveInDate': 'Færðu inn dagsetningu',
    'contract.deed.paymentBreakdown.moveInDateText': 'Færðu inn dagsetningu - Texti',
    'property.description': 'Texti',
    'property.description.full': 'Veftexti',
    'property.description.forReport': 'Söluyfirlits texti',
    'property.description.renovetions': 'Endurbætur',
    'property.description.knownDefects': 'Gallar',
    'property.description.openHouse': 'Opið hús/Sölusýning',
    'property.description.from': 'Frá',
    'property.description.to': 'Til kl.',
    'property.description.advertisement': 'Description (English)',
    'property.description.button.getStandardText': 'Sækja staðaltexta',
    'property.description.button.saveStandardText': 'Vista staðaltexta',
    'property.description.button.save': 'Uppfæra',

    'alert.notfoundData': 'Engin gögn fundust.',
    'type': 'Tegund',
    'customer': 'Viðskiptvinur',
    'description': 'Lýsing',
    'enquiry': 'Fyrirspurn',
    'enquiry.source': 'Uppruni',
    'enquiry.memo': 'Minnisatriði',
    'enquiry.addnote': 'Bæta við athugasemd',
    'enquiry.name': 'Nafn',
    'enquiry.status': 'Staða',
    'enquiry.dateAdded': 'Dags',
    'enquiry.saleRepresentative': 'Sölumaður',
    'enquiry.findMatchTooltip': 'Finna eignir sem uppfylla skilyrðin.',
    'save': 'Vista',
    'dashboard.addmore': 'Bæta við',
    'note': 'Athugasemd',
    'amount': 'Fjárhæð',
    'editor.writeSomething': 'Athugasemd',
    'restore': 'Endurheimta',
    'addmore': 'Bæta við',
    'done': 'Lokið',
    'search': 'Leit',
    'clear': 'Hreinsa',
    'firstProject' : 'Fyrsta eign',

    // Languages
    'language.th.sidebar': 'ภาษาไทย',
    'language.en.sidebar': 'English',
    'language.is.sidebar': 'íslenska',

    // ERRORS FROM UI-VALIDATION
    'error.offerDetail.name': 'Vinsamlega settu inn heiti tilboðs.',
    'error.offerDetail.name.exceedLength': 'Heiti tilboðs má ekki vera lengra en 255 stafir',
    'error.offerDetail.price': 'Tilboðsverð verður að vera hærra en 0',
    'error.offerDetail.offerStart': 'Vinsamlega veldu upphafsdagsetningu tilboðs.',
    'error.offerDetail.offerEnd': 'Vinsamlega veldu lokadagsetningu tilboðs.',
    'error.contractDetail.name': 'Vinsamlega skráðu heiti samnings.',
    'projectDetail.portal': 'Vef',
    'projectDetail.onWeb': 'Á vef',
    'projectDetail.notOnWeb': 'Ekki á vef',
    'projectDetail.viewOnWeb': 'skoða á vef',
    'error.projectDetail.projectName': 'Vinsamlega skráðu heiti verkefnis.',
    'error.projectDetail.projectRegId': 'Vinsamlega bætið við númeri verkefis.',
    'error.projectDetail.projectTypes': 'Vinsamlega veldu tegund verkefnis.',
    'error.projectDetail.developer': 'Vinsamlega bætið við aðila.',
    'error.projectDetail.totalUnits': 'Vinsamlega bætið við fjölda eininga.',
    'error.projectDetail.province': 'Vinsamlega veldu hérað.',
    'error.projectDetail.district': 'Vinsamlega veldu umdæmi.',
    'error.projectDetail.area': 'Vinsamlega veldu svæði.',
    'error.projectDetail.address': 'Vinsamlega setjið inn heimilisfang.',
    'error.projectDetail.yearBuilt': 'Vinsamlega setjið inn byggingarár.',
    'error.projectDetail.yearComplete': 'Framkvæmdalok verða að vera eftir að framkvæmdir hefjast.',
    'error.projectDetail.status': 'Vinsamlega veldu stöðu.',
    'error.projectDetail.landSize': 'Vinsamlega veldu stærð lands.',
    'error.projectDetail.landSize2': 'Stærð lands verður að vera stærra en 0.',
    'error.projectDetail.rai': '',
    'error.projectDetail.ngan': '',
    'error.projectDetail.wa': '',
    'error.projectDetail.projectIsDelete': 'Þetta verkefni er eytt',
    'error.projectDetail.permissionDenied': 'Leyfi hafnað',
    'error.projectUnit.unitName': 'Vinsamlega setjið inn heiti einingar.',
    'error.projectUnit.unitType': 'Vinsamlega setjið inn tegund einingar.',
    'error.projectUnit.size': 'Gildi verður að vera stærra en 0.',
    'error.projectDetail.videoLink': 'Vinsamlegast sláðu inn vefslóð YouTube',
    'error.projectEnquiry.contact': 'Vinsamlega veljið tengilið.',
    'error.projectEnquiry.propertyType': 'Vinsamlega veljið tegund eignar.',
    'error.projectEnquiry.size': 'Stærð verður að',
    'error.projectEnquiry.landSize': 'Verður að vera stærra en "Stærð frá".',
    'error.projectEnquiry.price': 'Verð til verður að vera hærra en verð frá.',
    'error.projectEnquiry.priceStart': 'Vinsamlega setjið inn verð frá',
    'error.projectEnquiry.priceTo': 'Vinsamlega setjið inn verið til.',
    'error.addNewUnit.unitNumber': 'Vinsamlega veljið fjölda eininga.',
    'error.addNewUnit.invalidUnitNumber': 'Fjöldi eininga verður að vera tala.',
    'error.addNewUnit.price': 'Vinsamlega settu inn verð.',
    'error.addNewUnit.price2': 'Verð til verður að vera hærra en verð frá.',
    'error.addNewUnit.minimumPrice': 'Vinsamlega setjið inn lágmarksverð.',
    'error.salesCommissionSetting.data.atleastone': 'Vinsamlega setjið inn a.m.k. eina færslu',
    'error.salesCommissionSetting.data.moreThanZero': 'Vinsamlega gætið að því að uppsafnaðar fjárhæðir séu hærri en 0.',
    'error.salesCommissionSetting.data.fromMoreThanTo': 'Vinsamlega setjið inn uppsafnaðar fjárhæðir frá hærri en 0.',
    'error.salesCommissionSetting.data.nonOverLap': 'Vinsamlega setjið inn uppsöfnuð gildi sem skarast ekki',
    'error.salesCommissionSetting.data.continuous': 'Vinsamlega haldið samfelllu í röð uppsafnaðra gilda',
    'error.salesCommissionSetting.data.cannotBeEmpty': 'Vinsamlega setjið inn uppsafnað gildi frá, uppsafnað gildi til eða þóknun.',
    'error.deedDetail.name': 'Please input deed name.',
    'error.deedDetail.id': 'Please input deed detail.',
    'error.priceToMustGreaterThanPriceFrom': 'Verð til verður að vera hærra en verð frá.',
    'error.minPriceToMustGreaterThanPriceFrom': 'Lægsta verð til verður að vera hærra en lægsta verð frá.',
    'error.pleaseInputPriceFrom': 'Vinsamlega setjið inn verð frá',
    'error.pleaseInputPriceTo': 'Vinsamlega setjið inn verið til',
    'error.pleaseInputMinPriceFrom': 'Vinsamlega setjið inn lægsta verð frá',
    'error.pleaseInputMinPriceTo': 'Vinsamlega setjið inn lægsta verið til',
    'error.pleaseInputName': 'Vinsamlegast sláðu inn nafn',
    'error.pleaseInputEmail': 'Vinsamlegast gefðu inn tölvupóst',
    'error.pleaseInputUsername': 'Vinsamlegast sláðu inn notandanafn',
    'error.pleaseInputPassword': 'Vinsamlegast settu inn lykilorð',
    'error.pleaseInputOldPassword': 'Vinsamlegast settu inn gömul lykilorð',
    'error.pleaseInputConfirmPassword': 'Vinsamlega skrifaðu staðfestu lykilorð',
    'error.pleaseInputValidEmail': 'Inntakið er ekki gilt E-mail!',
    'error.uploadLimitExceed': 'Hleðsla mynda yfir mörkum',

    // NOTIFICATIONS
    'notification.savecomplete': 'Upplýsingar hafa verið skráðar.',

    /*projectDetailNewUnitModal*/
    'projectDetailNewUnit.input.unitNumer': 'Númer',
    'projectDetailNewUnit.input.unitNumer.tooltip': 'Vinsamlega settu inn einingar og einingabil aðgreindar með kommu, s.s. 1, 3, 5-12.',
    'projectDetailNewUnit.input.rentOrSale': 'Leiga/Sala',
    'projectDetailNewUnit.input.sale': 'Sala',
    'projectDetailNewUnit.input.rent': 'Leiga',
    'projectDetailNewUnit.input.unitType': 'Tegund',
    'projectDetailNewUnit.input.price': 'Verð',
    'projectDetailNewUnit.input.minimumPrice': 'Lægsta verð',
    'projectDetailNewUnit.input.selectUnitType': 'Tegund',
    'projectDetailNewUnit.header.newUnit': 'Ný tegund',
    'projectDetailNewUnit.button.generate': 'Búa til',

    /*projectDetailNewEnquiryModal*/
    'projectDetailNewEnquiry.select.pleaseSelect': 'Vinsamlega veljið',
    'projectDetailNewEnquiry.select.contact': 'Viðskiptavinur',
    'projectDetailNewEnquiry.select.rentOrSale': 'Leiga/Sala',
    'projectDetailNewEnquiry.select.rent': 'Leiga',
    'projectDetailNewEnquiry.select.sale': 'Sala',
    'projectDetailNewEnquiry.input.type': 'Tegund',
    'projectDetailNewEnquiry.select.propertyType': 'Tegund eignar',
    'projectDetailNewEnquiry.input.sizeStart': 'Stærð (fm)',
    'projectDetailNewEnquiry.input.sizeEnd': 'til',
    'projectDetailNewEnquiry.input.landStart': 'Stærð lands (fm)',
    'projectDetailNewEnquiry.input.landEnd': 'til',
    'projectDetailNewEnquiry.input.priceStart': 'Verð',
    'projectDetailNewEnquiry.input.priceEnd': 'til',
    'projectDetailNewEnquiry.input.noOfBedrooms': 'Herbergi:',
    'projectDetailNewEnquiry.select.province': 'Póstnúmer',
    'projectDetailNewEnquiry.select.city': 'Póstfang',
    'projectDetailNewEnquiry.select.zone': 'Svæði',
    'projectDetailNewEnquiry.input.description': 'Lýsing',
    'projectDetailNewEnquiry.select.source': 'Uppruni',
    'projectDetailNewEnquiry.select.status': 'Staða',
    'projectDetailNewEnquiry.header.newEnquiry': 'Ný fyrirspurn',
    'projectDetailNewEnquiry.button.save': 'Vista',
    'projectDetailNewEnquiry.button.cancel': 'Hætta við',

    /* ERRORS from saga */
    'INVALID_LOGIN': 'Rangt notendanafn eða lykilorð.',

    // SETTING MODULE
    'setting.menu.enquiry.status': 'Fyrirspurn',
    'setting.menu.project.status': 'Verkefni',
    'setting.menu.employee.status': 'Starfsmaður',
    'setting.menu.office.status': 'Skrifstofa',
    'setting.menu.propertyAndProject.status': 'Eign/Verkefni',
    'setting.menu.sale.status': 'Sölur',
    'setting.menu.employee.detail': 'Starfsmannaupplýsingar',
    'setting.menu.employee.passwordAndAuthentication': 'Staðfesting/Útgáfa',
    'setting.menu.employee.salesHistory': 'Söluferill',
    'setting.text.title.statusName': 'Staða',
    'setting.text.title.statusDetail': 'Lýsing',
    'setting.text.title.sourceName': 'Uppruni',
    'setting.propertyAndProject.header.defect': 'Galli',
    'setting.propertyAndProject.header.delivery': 'Afhending',
    'setting.propertyAndProject.header.documentTemplate': 'Skjal',
    'setting.propertyAndProject.header.entrance': 'Inngangur',
    'setting.propertyAndProject.header.heating': 'Hitaveita',
    'setting.propertyAndProject.header.index': 'Vísitölur',
    'setting.propertyAndProject.header.commercialIndex': 'Vísitala atvinnuhúsnæðis',
    'setting.propertyAndProject.header.insurance': 'Tryggingar',
    'setting.propertyAndProject.header.language': 'Tungumál',
    'setting.propertyAndProject.header.material': 'Byggingarefni',
    'setting.propertyAndProject.header.mortgagee': 'Veðlán',
    'setting.propertyAndProject.header.propertyType': 'Eignaflokkar',
    'setting.propertyAndProject.header.livingPropertyType': 'Íbúðarhúsnæði',
    'setting.propertyAndProject.header.commercialPropertyType': 'Atvinnuhúsnæði',
    'setting.propertyAndProject.header.status': 'Staða',
    'setting.propertyAndProject.header.projectStatus': 'Staða verkefnis',
    'setting.propertyAndProject.header.propertyStatus': 'Staða eignar',
    'setting.propertyAndProject.header.source': 'Uppruni',
    'setting.propertyAndProject.header.projectSource': 'Uppruni verkefnis',
    'setting.propertyAndProject.header.propertySource': 'Uppruni eignar',
    'setting.propertyAndProject.header.usage': 'Notkun',
    'setting.propertyAndProject.header.window': 'Gluggar',
    'setting.propertyAndProject.table.item': 'Atriði',
    'setting.propertyAndProject.table.desc': 'Lýsing',
    'setting.enquiry.header.source.contact': 'Tengiliður - uppruni',
    'setting.enquiry.header.source.enquiry': 'Fyrirspurn - uppruni',
    'setting.salesCommission.header.Commission': 'Þóknun',
    'setting.salesCommission.header.title': 'Yfirlit yfir þóknun',
    'setting.salesCommission.table.accumulateSalesFrom': 'Uppsöfnuð Þóknun frá',
    'setting.salesCommission.table.accumulateSalesTo': 'Uppsöfnuð Þóknun til',
    'setting.salesCommission.table.commissionRate': 'Þóknun',
    'setting.salesCommission.button.edit': 'Breyta',
    'setting.salesCommission.button.delete': 'Eyða',
    'setting.salesCommission.button.add': 'Bæta við',
    'setting.salesCommission.button.updateCommission': 'Uppfæra þóknun',

    'setting.documentTemplate.text': 'Bakhliðatextar',
    'setting.documentTemplate.name': 'Document Name',
    'setting.documentTemplate.type': 'Tegund',
    'setting.documentTemplate.docType': 'Document Template Type',
    'setting.documentTemplate.docType.offer': 'Tilboð',
    'setting.documentTemplate.docType.contract': 'Samningar',
    'setting.documentTemplate.newDoc': 'New Document Template',

    'setting.documentTemplate.dynamicTag': 'Dynamic Tag',
    'setting.documentTemplate.propertyname': 'Property Name',
    'setting.documentTemplate.propertyprice': 'Property Price',
    'setting.documentTemplate.propertypricetext': 'Property Price Text',
    'setting.documentTemplate.propertyaddress': 'Heimilisfang',
    'setting.documentTemplate.propertyaddress2': 'Heimilisfang2',
    'setting.documentTemplate.propertyhousenumber': 'Húsnúmer',
    'setting.documentTemplate.propertysize': 'Property space',
    'setting.documentTemplate.propertyfloor': 'Property no of floor',
    'setting.documentTemplate.propertydeedno': 'Property deed no.',
    'setting.documentTemplate.propertyowner': 'Property owner',
    'setting.documentTemplate.propertyownerall': 'Property owner (All)',
    'setting.documentTemplate.documentname': 'Offer, Contract, Deed Name',
    'setting.documentTemplate.sellprice': 'Offer, Contract, Deed price',
    'setting.documentTemplate.buyername': 'Buyer Name',
    'setting.documentTemplate.buyernameall': 'Buyer Name (All)',
    'setting.documentTemplate.buyerid': 'Buyer ID number',
    'setting.documentTemplate.buyeridall': 'Buyer ID number (All)',
    'setting.documentTemplate.transferdate': 'Transfer Date',
    'setting.documentTemplate.contractdate': 'Contract Date',
    'setting.documentTemplate.deeddate': 'Deed Date',
    'setting.documentTemplate.previousdeeddue': 'Previous Deed Due',
    'setting.documentTemplate.paymentrec1': 'Payment Breakdown #1',
    'setting.documentTemplate.paymentrec2': 'Payment Breakdown #2',
    'setting.documentTemplate.paymentsummary': 'Payment Breakdown Summary',
    'setting.documentTemplate.mortgagesummary': 'Mortgage summary',
    'setting.documentTemplate.ilssummary': 'ILS Loan summary',
    'setting.documentTemplate.ilsextrasummary': 'ILS Loan Extra summary',
    'setting.documentTemplate.newloansummary': 'New Loan summary',
    'setting.documentTemplate.bondsummary': 'Bond summary',
    'setting.documentTemplate.allpaymentsummary': 'All Payment Summary',
    'setting.documentTemplate.ownerid': 'Owner ID',
    'setting.documentTemplate.owneridall': 'Owner ID (All)',

    'setting.documentTemplate.propertyownerphone': 'Eignarsími',
    'setting.documentTemplate.buyerphone': 'Kaupandi sími',
    'setting.documentTemplate.propertyowneremail': 'Netfang eiganda eiganda',
    'setting.documentTemplate.buyeremail': 'Netfang kaupanda',
    'setting.documentTemplate.propertyowneraddress': 'Heimilisfang eiganda',
    'setting.documentTemplate.buyeraddress': 'Heimilisfang kaupanda',
    'setting.documentTemplate.propertyownerage': 'Aldur fasteignaeiganda',
    'setting.documentTemplate.buyerage': 'Aldur kaupanda',
    'setting.documentTemplate.offerstartdate': 'Upphafsdagsetning tilboðs',
    'setting.documentTemplate.offerenddate': 'Lokadagsetning tilboðs',
    'setting.documentTemplate.offerstartdatebe': 'Upphafsdagur tilboðs B.E.',
    'setting.documentTemplate.offerenddatebe': 'Lokadagsetning tilboðs B.E.',
    'setting.documentTemplate.contractdatebe': 'Samningsdagur B.E.',
    'setting.documentTemplate.transferdatebe': 'Flutningardagur B.E.',
    'setting.documentTemplate.deeddatebe': 'Verkadagur B.E.',
    'setting.documentTemplate.propertylandsize': 'Stærð lands',
    'setting.documentTemplate.propertylandsizeth': 'Stærð fasteigna, Thai eining',
    'setting.documentTemplate.landnumber': 'Landnúmer',
    'setting.documentTemplate.salename': 'Nafn sölu',
    'setting.documentTemplate.salephone': 'Útsölu sími',
    'setting.documentTemplate.propertycommission': 'Fasteignaþóknun',
    'setting.documentTemplate.propertycommissionfixed': 'Fasta fasteign þóknun',
    'setting.documentTemplate.propertyexpiredate': 'Fasteignaskráning rennur út',
    'setting.documentTemplate.currentdate': 'Dagurinn í dag',
    'setting.documentTemplate.currentdatebe': 'Núverandi dagsetning B.E.',
    'setting.documentTemplate.signplace': 'Skilti stað',
    'setting.documentTemplate.saleaddress': 'Sölu heimilisfang',
    'setting.documentTemplate.saleage': 'Sölualdur',
    'setting.documentTemplate.propertyexpiredatebe': 'Fasteignaskráning rennur út B.E.',

    'setting.office.officeName': 'Nafn stofu',
    'setting.office.companyId': 'Kennitala',
    'setting.office.postalAddress': 'Póstfang',
    'setting.office.general': 'almennt',
    'setting.office.phoneNumber': 'Símanúmer',
    'setting.office.altAddress': 'Heimilisfang 2',
    'setting.office.faxNumber': 'Faxnúmer',
    'setting.office.sagaOfficeId': 'Saga auðkenni stofu',
    'setting.office.website': 'Vefsíða',
    'setting.office.showOnWeb': 'Sýna upplýsingar um fyrirtæki á vefnum',
    'setting.office.agentIsolation': 'einangrun einingarinnar',
    'setting.office.allowTextSelection': 'Enable text highlight',
    'setting.office.allowProjectList': 'Leyfa verkefnalista',
    'setting.office.showAgentDirectCall': 'Sýnið umboðsmanni beint',
    'setting.office.agentMapUrl': 'Agent Kort Url',
    'setting.office.slogan': 'Einkunnarorð',
    'setting.office.closer': 'Niðurlag',
    'setting.office.marketingBullet1': 'áherslupunktur 1',
    'setting.office.marketingBullet2': 'áherslupunktur 2',
    'setting.office.marketingBullet3': 'áherslupunktur 3',
    'setting.office.reportLogo': 'Merki í skjölum',
    'setting.office.webLogo': 'Merki fyrir vef',
    'setting.office.waterMark': 'Vatnsmerki',
    'setting.office.defaultProperty': 'Sjálfgefin eignamynd',
    'setting.office.officeDetail': 'Skrifstofa smáatriði',
    'setting.office.buyerCosts': 'Kostnaður kaupanda',
    'setting.office.loanCost': 'Lántökugjald',
    'setting.office.stampDutyContract': 'Stimpilgjald kaupsamnings',
    'setting.office.notarizingContract': 'Þinglýsing kaupsamnings',
    'setting.office.loanCostOfExtraLoan': 'Lántökugjald af viðbótarláni',
    'setting.office.stampDutyForLoan': 'Stimpilgjald veðbréfs',
    'setting.office.notarizingOfLoan': 'Þinglýsing veðbréfs',
    'setting.office.officeCost': 'Umsýslugjald',
    'setting.office.fmrEnabled': 'Virkja FMR',
    'setting.office.fmrAddress': 'FMR slóð',
    'setting.office.cityID': 'Auðkenni borgar',
    'setting.office.admakerAddress': 'AdMaker slóð',
    'setting.office.integratorId': 'lntegrator auðkenni',
    'setting.office.regionId': 'Auðkenni svæðis',
    'setting.office.trixboxAddress': 'Trixbox slóð',
    'setting.office.integratorOfficeId': 'lntegrator auðkenni stofu',
    'setting.office.intlOfficeId': 'Alþjóðlegt auðkenni stofu',
    'setting.office.externalPortal': 'External/Portal',
    'setting.office.portal': 'Vef',
    'setting.office.portalName': 'Name',
    'setting.office.email': 'Tölvupóstfang',
    'setting.office.public': 'Almenn',
    'setting.office.enable': 'Ávirk',
    'setting.office.csEnable': 'CS Ávirk',
    'setting.office.default': 'Sjálfsgefið',
    'setting.office.userName': 'Notendanafn',
    'setting.office.password': 'Lykilorð',
    'setting.office.url': 'Netþjóns',
    'setting.office.darkpoolID': 'Darkpool auðkenni',
    'setting.office.darkpoolKey': 'Darkpool Lykill',
    'setting.office.sendUsers': 'Senda starfsmenn',
    'setting.office.sendProperty': 'Senda eignir',
    'setting.office.darkpoolAddress': 'Darkpool slóð',
    'setting.office.darkpoolAddressNote': 'Athugið að með því að setja tvípunkt (:) hvar sem er í heimilisfangi, þá er allt aftan við (:) klippt af við sendingu á vef.',
    'setting.office.darkpoolAddressFormat': 'Heimilisfang snið',
    'setting.office.sendAsInSagaEign': 'Senda allt heimilisfangið með húsnúmeri',
    'setting.office.sendOnlyStreetName': 'Senda aðeins götuheiti án húsnúmers',
    'setting.employee.header.id': 'ID',
    'setting.employee.header.userName': 'Notendanafn',
    'setting.employee.header.name': 'Nafn',
    'setting.employee.header.role': 'Hlutverki',
    'setting.employee.header.email': 'Tölvupóstur',
    'setting.employee.header.mobilePhone': 'Farsími',
    'setting.employee.header.status': 'Staða',
    'setting.employee.showInactiveUser': 'Sýna óvirka notendur',
    'setting.employee.addNewEmployee': 'Bæta við nýjum notanda',
    'setting.employee.detail.general': 'Almennt',
    'setting.employee.detail.firstName': 'Fornafn',
    'setting.employee.detail.middleName': 'Millinafn',
    'setting.employee.detail.lastName': 'Eftirnafn',
    'setting.employee.detail.ssn': 'Kennitala',
    'setting.employee.detail.dateOfBirth': 'Fæðingardagur',
    'setting.employee.detail.gender': 'Kyn',
    'setting.employee.detail.lineId': 'WhatsApp ID',
    'setting.employee.detail.lineQR': 'WhatsApp QR',
    'setting.employee.detail.workNumber': 'Vinna Sími',
    'setting.employee.detail.mobileNumber': 'Farsími',
    'setting.employee.detail.mobileNumber2': 'Farsími 2',
    'setting.employee.detail.otherNumber': 'Annað Sími',
    'setting.employee.detail.website': 'Vefsíða',
    'setting.employee.detail.publishing': 'Útgáfa',
    'setting.employee.detail.showEmployeeDetailOnWeb': 'Sýna upplýsingar um starfsmenn á vefnum',
    'setting.employee.detail.showPictureInSalesReport': 'Sýna mynd í söluskýrslu',
    'setting.employee.detail.showPictureInPropertyList': 'Sýna mynd á eignalista',
    'setting.employee.detail.job': 'Starf',
    'setting.employee.detail.titile': 'Titill',
    'setting.employee.detail.teamStatus': 'Staða laga',
    'setting.employee.detail.slogan': 'Slagorð',
    'setting.employee.detail.closer': 'Closer',
    'setting.employee.detail.languages': 'Tungumál',
    'setting.employee.detail.specialities': 'Sérstaða',
    'setting.employee.detail.educations': 'Náms',
    'setting.employee.detail.description': 'Lýsing',
    'setting.employee.detail.marketingBullet1': 'Marketing Bullet 1',
    'setting.employee.detail.agentId': 'Umboðsmaður auðkenni',
    'setting.employee.detail.sagaUserId': 'SAGA user ID',
    'setting.employee.detail.ddPropertyAgentId': 'DDProperty agent ID',
    'setting.employee.detail.dateRegistered': 'Dagsetning skráð',
    'setting.employee.detail.watermark': 'Vatnsmerki',
    'setting.employee.detail.applyWatermarkWhenSendingToWeb': 'Notaðu vatnsmerki þegar þú sendir á vefinn',
    'setting.employee.detail.applyWatermarkWhenSendinOnEmain': 'Notaðu vatnsmerki þegar þú sendir á tölvupósti',
    'setting.employee.detail.applyWatermarkWhenDownloadingPhotos': 'Notaðu vatnsmerki þegar þú hleður niður myndum',
    'setting.employee.detail.watermarkPosition': 'Vatnsmerki staða',
    'setting.employee.detail.massPropertyUpdateFunctions': 'Mass property update fuctions',
    'setting.employee.detail.updatePropertiesFromFMR': 'Update properties from FMR',
    'setting.employee.detail.updatePropertiesOnWeb': 'Update properties on web',
    'setting.employee.detail.updatePropertiesFromFMRRemark': 'Clicking on this button will update all your properties with information from FMR. Properties, which are parts of large complexes and share property ID with other parts, will not be updated, but shown to you, so that you can manually choose which parts are they. Updating property with FMR information will update properties on the web',
    'setting.employee.detail.updatePropertiesOnWebRemark': 'If you feel that some of properties are not up to date on the web, you can update all of them by clicking on this button',
    'setting.employee.detail.paymentSetting': 'Greiðsla stilling',
    'setting.employee.detail.percentCutOfSalesFee': '% cut of sales fee',
    'setting.employee.detail.Salary': 'Laun',
    'setting.employee.detail.Bonus': 'Bónus',
    'setting.employee.detail.yearPaymentsToTheOffice': 'Yearly payments to the office',
    'setting.employee.detail.MonthlyInconeForTheOfficeFrom': 'Monthly income for the office from',
    'setting.employee.detail.perYear': 'Per year',
    'setting.employee.detail.perMonth': 'Per month',
    'setting.employee.detail.otherPaymentsToOffice1': 'Aðrar greiðslur til skrifstofu 1',
    'setting.employee.detail.otherPaymentsToOffice2': 'Aðrar greiðslur til skrifstofu 2',
    'setting.employee.detail.contractPayment': 'Samningur greiðsla',
    'setting.employee.detail.authentication': 'Auðkenning',
    'setting.employee.detail.username': 'Notendanafn',
    'setting.employee.detail.oldPassword': 'Gamalt lykilorð',
    'setting.employee.detail.newPassword': 'nýtt lykilorð',
    'setting.employee.detail.password': 'Lykilorð',
    'setting.employee.detail.confirmPassword': 'Staðfesta lykilorð',
    'setting.employee.detail.confirmNewPassword': 'Staðfestu nýtt lykilor',
    'setting.employee.detail.admakerUsername': 'Admarker notendanafn',
    'setting.employee.detail.admakerPassword': 'Admarker lykilorð',
    'setting.employee.detail.rights': 'Réttindi',
    'setting.employee.detail.expireDate': 'Gildistími',
    'setting.employee.detail.inactiveThisUser': 'Óvirkt þessi notandi',
    'setting.employee.detail.inactiveThisUserRemark': 'Þessi notandi mun ekki fá aðgang að þessu kerfi, en öll eign sem enn er úthlutað til notandans',
    'setting.employee.detail.activeThisUser': 'Virkja þennan notanda',
    'setting.employee.detail.autogenerateUsename': 'Sjálfkrafa mynda notendanafn',
    'setting.employee.detail.inactiveModal.header': 'Properties of a user who is being de-activated',
    'setting.employee.detail.inactiveModal.title1': 'User who is being de-activated has ',
    'setting.employee.detail.inactiveModal.title2': ' active properties ( ',
    'setting.employee.detail.inactiveModal.title3': ' of them are on the web) and ',
    'setting.employee.detail.inactiveModal.title4': ' properties in storage. What would you like to do?',
    'setting.employee.detail.inactiveModal.movetoUser': 'Move all properties to another user',
    'setting.employee.detail.inactiveModal.keepPropertiesOnWeb': 'Keep properties on the web as they are now',
    'setting.employee.detail.inactiveModal.pullPropertiesInStorage': 'Put all properties in storage (properties which are on the web will be removed from the web and all properties can be found in Storage tab in property list under de-activated user)',
    'setting.employee.detail.inactiveModal.doNothing': 'Do nothing',
    'setting.employee.detail.inactiveModal.warning': 'Warning: action selected above and confirmed by clicking OK can not be rolled back later.',
	'setting.employee.detail.isAuthorized': 'Er heimilt',
    'setting.employee.detail.allowCreateUsers': 'Leyfa að búa til notendur',
    'setting.employee.detail.restrictExport': 'Takmarkaðu útflutning',
    'setting.employee.detail.isAllowViewContact': 'Er leyft að skoða tengilið',
    'setting.employee.detail.ssl': 'SSL',
    'setting.employee.detail.sentToMeAsBcc': 'Sendið mér til Bcc',
    'setting.employee.detail.smtpServerName': 'SMTP Server nafn',
    'setting.employee.detail.smtpUsername': 'SMTP notendanafn',
    'setting.employee.detail.smtpPassword': 'SMTP lykilorð',
    'setting.employee.detail.smtpPort': 'SMTP Port',
    'setting.employee.detail.pop3ServerName': 'POP3 Server nafn',
    'setting.employee.detail.pop3Username': 'POP3 notendanafn',
    'setting.employee.detail.pop3Password': 'POP3 lykilorð',
    'setting.employee.detail.pop3Port': 'POP3 Port',
    'setting.employee.detail.signature': 'Undirskrift',

    'setting.propertylist.availableList': 'tiltæk listi',
    'setting.propertylist.selectedList': 'Valdar listi',
    'setting.propertylist.moveUp': 'Fara upp',
    'setting.propertylist.moveDown': 'Fara upp',
    'setting.propertylist.update': 'Uppfæra',

    'delete': 'Eyða',
    'edit': 'Breyta',
    'cancel': 'Hætta við',
    'ok': 'OK',
    'update': 'Vista',
    'sureDelete': 'Ertu viss um að vilja eyða?',
    'sureCancel': 'Ertu viss um að vilja hætta við?',
    'sureDone': 'Halda áfram?',
    'default': 'Sjálfgefið',
    'setDefault': 'Velja sjálfgefið',
    'view': 'Útsýni',
    'upload': 'Hlaða inn',
    'deleteSelectedRecord': 'Eyða völdum aðilum',

    'report.propertyReport.propertyReport': 'Eignalisti',
    'report.propertyReport.isExclusive': 'Tegund sölu',
    'report.propertyReport.dateFrom': 'Dags. frá',
    'report.propertyReport.dateTo': 'Dags. til',
    'report.propertyReport.advanceFilter': 'Frekari takmörkun',
    'report.propertyReport.propertyId': 'Fastanúmer',
    'report.propertyReport.address2': 'Heimilisf. 2',
    'report.propertyReport.priceFrom': 'Verð frá',
    'report.propertyReport.priceTo': 'Verð að',
    'report.propertyReport.exclusive': 'Einkasala',
    'report.propertyReport.nonExclusive': 'Almenn sala',

    'description.forReport': 'Söluyfirlits texti',
    'description.standardText': 'Sækja staðaltexta',
    'description.saveStandardText': 'Vista staðaltexta',
    'description.renovation': 'Endurbætur',
    'description.knownDefects': 'Gallar',
    'description.openHouse': 'Veftexti:	Opið hús/Sölusýning',
    'description.advertisement': 'Description',
    'description.portal': 'Website Lýsing',

    'alertModal.duplicateBuyer': 'Ekki er hægt að skrá sama aðila tvisvar.',

    'oldLoan':'Yfirtekin lán',
    'ilsloan': 'ÍLS',
    'newLoan': 'Skilyrt veðleyfi',
    'bond': 'Skuldabréf',
    'loan.propertyLoan': 'Veðskuldir',
    'loan.takenLoan': 'Yfirtekin lán',
    'loan.mortgageRight': 'Veðréttur',
    'loan.takeOver': 'YAS',
    'loan.mortgagee': 'Veðhafi',
    'loan.interest': 'Vextir',
    'loan.originalAmount': 'Höfuðstóll',
    'loan.loanRemainder': 'Eftirstöðvar',
    'loan.payment':'Greiðslub',
    'loan.remainingPayment':'Afb.eftir.',
    'loan.nextPaymentDue':'Næsti gjaldd.',
    'loan.takenOverSum': 'Samtals Yfirtekið',
    'loan.canceledSum': 'Samtals Aflýst',
    'loan.agreedSum': 'Samtals Samkomulag',
    'loan.paymentPerPeriodSum': 'Greiðslubyrði á gjaldd',
    'loan.loanAmountSum': 'Samtals áhv',
    'loan.loanTakenOn':'Útgáfudagur',
    'loan.costToPay':'Uppgreiðslugjald',
    'loan.baseIndex':'Grunnvísitala',
    'loan.firstPayment':'Fyrsti gjaldd. kaupanda',
    'loan.lockedRemainder':'Læstar eftirstöðvar',
    'loan.AdditionalAmount': 'Viðaukabréf fjárhæð',
    'loan.InterestedCalculatedFrom': 'Vextir reiknast frá',
    'loan.InterestedCalculatedFromText': 'Vextir reiknast frá - Texti',
    'loan.paymentPerYear': 'Gjaldd.ár hvert',
    'loan.numberOfYear': 'Fjöldi ára',
    'loan.numberOfPayment': 'Fjöldi afborgana',
    'loan.standardText': 'Skýring',
    'loan.title': 'Lánstitill',
    'loan.payOutDate': 'Útgáfud. Í síðasta lagi',
    'bond.title': 'Skuldabréf Lánstitill',
    'loan.contractDate': 'Dags. kaupsamnings',
    'loan.deedDate': 'Dagsetning Afsals',
    'loan.transferDate': 'Aflýsingardagur',
    'loan.previousDeedDue': 'Dagsetning Veðbókar',
    'loan.newLoan.NumberOfPaymentsHelp':'Margfeldi gildanna: "Gjaldd. ár hvert" og "Fjöldi ára".',

    'contact.allContacts': 'Tengiliðir',
    'contact.myContacts': 'Mínir tengiliðir',
    'contact.allEnquiries': 'Fyrirspurnir',
    'contact.myEnquiries': 'Mínar fyrirspurnir',
    'contact.allLeads': 'Allar ábendingar',
    'contact.myLeads': 'Mínar ábendingar',
    'contact.dateAdded': 'Dagsetning',
    'contact.exportSelected': 'Birta valda í Excel',
    'contact.exportAll': 'Birta alla í Excel',
    'contact.contactDetail.ssn': 'Kennitala',
    'contact.contactDetail.homeAddress': 'Heimilifang',
    'contact.contactDetail.homePhone': 'Heimasími',
    'contact.contactDetail.workPhone': 'Vinnusími',
    'contact.contactDetail.mobilePhone': 'Farsími',
    'contact.contactDetail.email': 'Tölvupóstur',
    'contact.contactDetail.lineId': 'WhatsApp ID',
    'contact.contactDetail.company': 'Fyrirtæki',
    'contact.contactDetail.position': 'Starfsheiti',
    'contact.contactDetail.website': 'Vefsíða',
    'contact.contactDetail.spouse': 'Maki',
    'contact.contactDetail.birthDate': 'Afmælisdagur',
    'contact.contactDetail.assignToSale': 'Sölumaður',
    'contact.contactDetail.source': 'Uppruni',
    'contact.contactDetail.status': 'Staða',
    'contact.contactDetail.remind': 'Fá áminningu',
    'contact.contactDetail.memo': 'Minnisatriði',
    'contact.contactDetail.signature': 'Undirskrift',
    'contact.contactDetail.button.email': 'Tölvupóstur',
    'contact.contactDetail.button.nameCard': 'Nafnspjald',
    'contact.contactDetail.button.calendar': 'Dagatal',
    'contact.contactDetail.button.relatedProperty': 'Eignir',
    'contact.contactDetail.button.relatedDocument': 'Skjöl',
    'contact.contactDetail.button.leads': 'Ábendingar',
    'contact.contactDetail.button.enquiries': 'Enquiries',
    'contact.contactDetail.propertyStatus': 'Staða Eign',
    'contact.contactDetail.relatedStatus': 'Related Status',
    'contact.contactDetail.relatedProperty': 'Eignir',

    'enquiry.enquiryDetail.create': 'Ný fyrirspurn',
    'enquiry.enquiryDetail.update': 'Fyrirspurn',
    'enquiry.enquiryDetail.mustSelectlease1Field':'Must have value lease 1 field.',
    'enquiry.matchProperty.utilizeSpace':'Stærð húsn.',
    'enquiry.matchProperty.action':'Aðgerð',
    'enquiry.matchProperty.created':'Skoða ábendingu',
    'enquiry.matchProperty.createLead':'Búa til ábendingu',
    'enquiry.matchProperty.findMatched':'Finna eignir',
    'enquiry.matchProperty.matchedProperties':'Eignir',
    
    'lead.table.header.propertyname': 'Eign',
    'lead.leadDetail.header': 'Ábending',
    'lead.leadDetail.customerName': 'Nafn viðskiptavinar',
    'lead.leadDetail.interestedProperty': 'Eign',
    'lead.leadDetail.callDate': 'Dagsetning',
    'lead.leadDetail.openHouse': 'Opið hús',
    'lead.leadDetail.source': 'Uppruni',
    'lead.leadDetail.status': 'Staða',
    'lead.leadDetail.noPropertyName': 'Engin eignarheiti',

    'batch.source' : 'Uppruni',
    'batch.status' : 'Staða',
    'batch.selectStatus': 'Vinsamlega veljið stöðu',
    'batch.selectSource': 'Vinsamlega veljið uppruna',
    'batch.selectOnWeb': 'Velja Á vef',

    'email.to': 'Til',
    'email.cc': 'Cc',
    'email.subject': 'Efni',
    'email.sendEmail': 'Senda Email',
    'email.attachmentPolicy': 'Myndskráin verður að vera minni en 1 MB / Önnur skrá verður að vera minni en 10 MB',
    'email.sendComplete': 'Tölvupóstur hefur verið sendur',

    'contact.sendDetail': 'Senda í vinnslu',

    'offerEvent': `Tilboð`,
    'contractEvent': `Kaupsamningur`,
    'deedEvent': `Afsal`,
    'leadEvent': `Ábending`,
    'propertyactivityEvent': `Eignarleiki`,
    'birthdayEvent': 'Afmælisdagur',
    'propertyopenhouseEvent': 'Opið hús',
    'propertyexpireEvent': 'Gildistími',
    'calendar.myCalendar': 'Mitt dagatal',
    'calendar.allCalendar': 'Öll dagatöl',

    'financialStatement.portalAddress': 'Póstnúmer',
    'financialStatement.paymentSummary': 'Yfirlit yfir greiðslur',
    'financialStatement.offerPrice': 'Offer price',
    'financialStatement.mortgage': 'Yfirtekin lán',
    'financialStatement.ilsLoan': 'ÍLS - Veðbréf',
    'financialStatement.ilsLoanExtra': 'Viðbótarlán',
    'financialStatement.newLoan': 'Skilyrt veðleyfi',
    'financialStatement.bonds': 'Skuldabréf',
    'financialStatement.paymentSum': 'Samtals',
    'financialStatement.diff': 'Mismunur',

    'propertyList.myProperty':'Mínar eignir',
    'propertyList.allProperty':'Allar eignir',
    'propertyList.owner':'Eignarhluti',
    'propertyList.modifiedOn': 'Breytingar',
    'propertyList.propertyAddress':'Heimilisfang',
    'propertyList.addProperty':'Add Property',
    'propertyList.newForSale':'New for Sale',
    'propertyList.newForRent':'New for Rent',
    'propertyList.recentActivity':'Nýleg virkni',

    'propertyDetail': 'Lýsing',
    'propertyDetail.description': 'Texti',
    'propertyDetail.findLocationFromAddress': 'Finna staðsetningu út frá heimilisfangi',
    'propertyDetail.updateFromFMR': 'Sækja ný gögn frá FMR',
    'propertyDetail.viewOnFMR': 'Opna FMR',
    'propertyDetail.landNumber': 'Landeignanúmer',
    'propertyDetail.landSize': 'Stærð',
    'propertyDetail.landSizeSqm': 'Stærð',
    'propertyDetail.propertyPart': 'Eignahluti',
    'propertyDetail.houseAppraisal': 'Húsmat',
    'propertyDetail.buildingFloor': 'Hæðir',
    'propertyDetail.unitFloor': `Eining hæð`,
    'propertyDetail.bedroom': 'Svefnherbergi',
    'propertyDetail.bathroom': 'Baðherbergi',
    'propertyDetail.livingroom': 'Stofur',
    'propertyDetail.totalroom': 'Herbergi alls',
    'propertyDetail.aircondition': 'Loftkæling',
    'propertyDetail.parkingLot': 'Bílskúr',
    'propertyDetail.storage': 'Geymsla',
    'propertyDetail.balcony': 'Svalir',
    'propertyDetail.laundry': 'Þvottahús',
    'propertyDetail.garden': 'Garður',
    'propertyDetail.otherroom': 'Önnur rými',
    'propertyDetail.buildingStage': 'Byggingarstig',
    'propertyDetail.delivery': 'Afhending',
    'propertyDetail.entrance': 'Inngangur',
    'propertyDetail.heating': 'Upphitun',
    'propertyDetail.windows': 'Gler/gluggar',
    'propertyDetail.groundFloorMaterial': 'Gólfefni á jarðhæð',
    'propertyDetail.upperFloorMaterial': 'Gólfefni á efri hæð',
    'propertyDetail.elevator': 'Lyfta',
    'propertyDetail.preemption': 'Forkaupsréttur',
    'propertyDetail.exchangeAgreementNo': 'Eignaskiptasamningur nr.',
    'propertyDetail.mapSheetNo': 'Mapsheet no.',
    'propertyDetail.parcelNo': 'Parcel no.',
    'propertyDetail.dealingFileNo': 'Dealing file no.',
    'propertyDetail.groundLeaseAgreementNo': 'Lóðarleigusamningur nr.',
    'propertyDetail.encumbranceFileNo': 'Kvöð, skjal nr.',
    'propertyDetail.encumbranceStatement': 'Veðbandayfirlit',
    'propertyDetail.encumbranceNote': 'Encumbrance note',
    'propertyDetail.taxAndCost': 'Skattar og gjöld',
    'propertyDetail.orderTax': 'Panta',
    'propertyDetail.waterTax': 'Vatnsgjald',
    'propertyDetail.fireInsurance': 'Brunatrygging á ári',
    'propertyDetail.orderInsurance': 'Panta',
    'propertyDetail.monthlyCost': 'Hússjóður á mánuði',
    'propertyDetail.rentalDetail': 'Nánar um leigu',
    'propertyDetail.rentPeriod': 'Leigutími',
    'propertyDetail.paymentFrequency': 'Greiðslutíðni',
    'propertyDetail.rentInsurance1': 'Trygging 1',
    'propertyDetail.rentInsurance2': 'Trygging 2',
    'propertyDetail.deliveryFrom': 'Afhending frá',
    'propertyDetail.deliveryTo': 'Afhending til',
    'propertyDetail.electricity': 'Rafmagn',
    'propertyDetail.water': 'Vatn',
    'propertyDetail.other': 'Annað',
    'propertyDetail.index': 'Vísitala',
    'propertyDetail.propertyManagement': 'Rekstur eignar',
    'propertyDetail.management': 'Almennur rekstur',
    'propertyDetail.janitorSalary': `Laun húsvarðar`,
    'propertyDetail.cleaningOfJointArea': 'Þrif sameignar',
    'propertyDetail.electricityInJointArea': 'Rafmagn í sameign',
    'propertyDetail.cleaningOfWasteDisposalArea': 'Þrif sorpgeymslu',
    'propertyDetail.homeOwnerInsurance': 'Húseigendatrygging',
    'propertyDetail.paymentDueDate': 'Greiðsludagsetning',
    'propertyDetail.commercialBuildingSpecification': 'Nánar um eign',
    'propertyDetail.premisesSize': `Lengd x breidd lóðar`,
    'propertyDetail.buildingSize': `Lengd x breidd húss`,
    'propertyDetail.floorArea': 'Gólfflötur',
    'propertyDetail.loftArea': 'Þar af milliloft',
    'propertyDetail.bearingCapacity': 'Burðargeta gólfplötu',
    'propertyDetail.ridgeHeight': 'Mænishæð',
    'propertyDetail.highestWall': 'Mesta vegghæð',
    'propertyDetail.lowestWall': 'Minnsta vegghæð',
    'propertyDetail.sizeInCubicMeter': 'Stærð í rúmmetrum',
    'propertyDetail.noOfDirveThroughDoor': 'Fjöldi innkeyrsluhurða',
    'propertyDetail.heightOfDriveThroughDoor': 'Hæð innkeyrsluhurða',
    'propertyDetail.roof': 'Þak',
    'propertyDetail.noOfGroundParkingSpace': 'Fjöldi bílastæða á lóð',
    'propertyDetail.buildingRight': 'Byggingarréttur',
    'propertyDetail.groundFloor': 'Jarðhæð',
    'propertyDetail.rentPrice': 'Leiguverð',
    'propertyDetail.rentIncome': 'Leigutekjur',
    'propertyDetail.rentStarted': 'Útleiga hefst',
    'propertyDetail.rentEnd': 'Útleiga endar',
    'propertyDetail.termOfannulment': 'Uppsagnarákvæði',
    'propertyDetail.loadingDoor': 'Gámahleðsludyr',
    'propertyDetail.saleCommission': 'Söluprósenta',
    'propertyDetail.saleCommission.exceedPercent': `Getur ekki farið yfir 100%`,
    'propertyDetail.saleCommissionFixed': 'Föst söluþóknun',
    'propertyDetail.brokerageContract': 'Tegund sölu',
    'propertyDetail.openContract': 'Almenn sala',
    'propertyDetail.exclusiveContract': 'Einkasala',
    'propertyDetail.featured': 'Kynning',
    'propertyDetail.advertised': 'Auglýst',
    'propertyDetail.listingDate': 'Dags. skráningar',
    'propertyDetail.listingExpireDate': 'Gildistími',
    'propertyDetail.propertyStatus': 'Staða',
    'propertyDetail.error.selectAgent': 'Please select sale representative',
    'propertyDetail.archived': 'Í geymslu',
    'propertyDetail.deleted': 'Eyða',
    'propertyDetail.createLead': 'Skrá ábendingu',
    'propertyDetail.showLead': 'Skoða ábendingar',
    'propertyDetail.convertToRent': 'Breyta í leigueign',
    'propertyDetail.convertToSale': 'Breyta í sölueign',
    'propertyDetail.convertToCommercial': 'Breyta í atvinnueign',
    'propertyDetail.convertToResidential': 'Beyta í íbúðarhúsnæði',
    'propertyDetail.duplicate': 'Afrita eign',
    'propertyDetail.archive': 'Færa í geymslu',
    'propertyDetail.unArchive': 'Unarchive',
    'propertyDetail.publishing': 'Senda á vef',
    'propertyDetail.inProgress': 'í vinnslu',
    'propertyDetail.sureToArchive': 'Sure to archive?',
    'propertyDetail.video': 'Videos',
    'propertyDetail.blueprints': 'Teikningar',
    'propertyDetail.files': 'Skrár',
    'propertyDetail.sizeSqureMeter': 'Stærð (Sq.m)',
    'propertyDetail.error.valueExceedLength': 'Value exceed limit length.',
    'propertyDetail.error.limitLength': 'Value can be at most',
    'propertyDetail.error.character': 'characters',
    'propertyDetail.error.invalidEmail': 'อีเมล์ไม่ถูกต้อง',
    'propertyDetail.pictureAndFiles': 'Myndir/Skrár',
    'propertyPicture.applyWatermarkSendingToWeb': 'Myndir á vef',
    'propertyPicture.watermarkPosition': 'Staðsetning vatnsmerkis',
    'propertyPicture.watermarkSetting': 'Vatnsmerki - stillingar',
    'propertyPicture.previewWatermark': 'Vatnsmerki',
    'propertyPicture.useUserSetting': 'Nota stillingar sölumanns (hér má breyta sjálfgefnum stillingum)',
    'propertyPicture.useSpecificSetting': 'Nota sér stillingar fyrir þessa eign (í stað stillinga sölumanns)',
    'propertyPicture.topLeft': 'Efst til vinstri',
    'propertyPicture.topRight': 'Efst til hægri',
    'propertyPicture.bottomLeft': 'Neðst til vinstri',
    'propertyPicture.bottomRight': 'Neðst til hægri',
    'propertyPicture.center': 'Miðja',
    'propertyPicture.addVideo': 'Bæta við myndbandi',
    'propertyPicture.url': 'Slóð',
    'propertyPicture.title': 'Vdo Titll',
    'propertyPicture.pleaseInputUrl': 'Vinsamlegast settu inn slóð',
    'propertyDetail.convertTypeDescription': 'Eftir að eign hefur verið breytt, þá er eldri eignin ekki lengur til. Vinsamlega veljið nýja eignategund og smellið á OK til að halda áfram.',
    'propertyDetail.owners': 'Eigendur',
    'propertyPicture.ownerInformation': 'Upplýsingar um eiganda',
    'propertyPicture.renterInformation': 'Upplýsingar um leigjanda',
    'propertyDetail.Loans': 'Lán',
    'propertyLoan.vr': 'Veðréttur',
    'propertyLoan.takeOver': 'YAS',
    'propertyLoan.mortgagee': 'Veðhafi',
    'propertyLoan.interest': 'Vextir',
    'propertyLoan.originalAmount': 'Höfuðstóll',
    'propertyLoan.loanRemainder': 'Eftirstöðvar',
    'propertyLoan.payment': 'Greiðslubyrði',
    'propertyLoan.remainingPayment': 'Afb. eftir',
    'propertyLoan.nextPaymentDue': 'Næsti gjaldd.',
    'propertyLoan.notSendToWeb': 'Ekki sent á vef',
    'propertyLoan.summaryByMortgagee': 'Samtala veðhafa',
    'propertyLoan.summaryByLoanStatus': 'Samtala lána',
    'propertyLoan.status': 'Staða',
    'propertyLoan.amount': 'Fjárhæð',
    'propertyLoan.currency': 'Mynt',
    'propertyLoan.exchangeRate': 'Gengi',
    'propertyLoan.originalCurrencyAmount': 'Upphafleg fjarhæð í mynt',
    'propertyLoan.interestRate': 'Vaxtaprósenta',
    'propertyLoan.loanNumber': 'Lánsnúmer',
    'propertyLoan.pledge': 'Veð',
    'propertyLoan.originalPayment': 'Upph. fjöldi gjaldd',
    'propertyLoan.baseIndex': 'Grunnvísitala',
    'propertyLoan.index': 'Vísitala',
    'propertyLoan.todayIndex': 'Vísitala í dag',
    'propertyLoan.typeOfLoan': 'Lánstegund',
    'propertyLoan.correction': 'Leiðrétting',
    'propertyLoan.lockedRemainder': 'Læstar eftirstöðvar',
    'propertyLoan.paymentPerYear': 'Fjöldi gjaldd. á ári',
    'propertyLoan.paymentCorrection': 'Leiðrétt afborgun',
    'propertyLoan.lockedPayment': 'Læst afborgun',
    'propertyLoan.startDate': 'Útgáfudagur',
    'propertyLoan.realCost': 'Uppgreiðslugjald',
    'propertyLoan.remark1': 'IEf nauðsynlegar upplýsingar eru ekki settar inn (rauðir reitir) þá mun lánareiknirinn ekki reikna út eftirstöðvar',
    'propertyLoan.remark2': 'Lánareiknir notar sömu formúlu og lánveitendur til að reikna út eftirstöðvar og mánaðarlega greiðslubyrði. Ekki er hægt að gera ráð fyrir breytingum út frá upphaflegri greiðsluáætlun.',
    'propertyLoan.validate.lessThan' : 'Remaining Payment must less than Original Payments',
    'propertyDetail.activityLog': 'Virkniskrá',
    'propertyDetail.history': 'Saga',
    'propertyActivityLog.addActivity': 'Add activity',
    'propertyActivityLog.editActivity': 'Edit activity',
    'propertyHistory.sureToRestore': 'Staðfestu að endurheimta þessa skrá'
};



// WEBPACK FOOTER //
// ./src/languageProvider/locales/is_IS.ts